/*! lightbox - v1.0.0 Build date: 2017-10-10
	Wrapper for PhotoSwipe (http://photoswipe.com) Copyright (c) 2015 Dmitry Semenov
	*/
import { subscribe, unsubscribe, dispatch } from '../customEvents';

import _ from 'lodash'

import { helpers } from "@cargo/common";

let lightboxRoot = {};

if(!helpers.isServer) {
	lightboxRoot = window.lightbox = {};
}

 ;(function(){
 'use strict';

 /*! PhotoSwipe - v4.1.2 - 2017-04-05
* http://photoswipe.com
* Copyright (c) 2017 Dmitry Semenov; */
(function (root, factory) {

	if(root === undefined && window !== undefined) root = window
	root.PhotoSwipe = factory();

})(this, function () {

	'use strict';
	var PhotoSwipe = function(template, UiClass, items, options){
/*>>framework-bridge*/
/**
 *
 * Set of generic functions used by gallery.
 *
 * You're free to modify anything here as long as functionality is kept.
 *
 */
var framework = {
	features: null,
	bind: function(target, type, listener, unbind) {

		var methodName = (unbind ? 'remove' : 'add') + 'EventListener';
		type = type.split(' ');
		for(var i = 0; i < type.length; i++) {
			if(type[i]) {
				target[methodName]( type[i], listener, false);
			}
		}
	},
	isArray: function(obj) {
		return (obj instanceof Array);
	},
	createEl: function(classes, tag) {
		var el = document.createElement(tag || 'div');
		if(classes) {
			el.className = classes;
		}
		return el;
	},
	getScrollY: function() {
		var yOffset = window.pageYOffset;
		return yOffset !== undefined ? yOffset : document.documentElement.scrollTop;
	},
	unbind: function(target, type, listener) {
		framework.bind(target,type,listener,true);
	},
	removeClass: function(el, className) {
		var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
		el.className = el.className.replace(reg, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	},
	addClass: function(el, className) {
		if( !framework.hasClass(el,className) ) {
			el.className += (el.className ? ' ' : '') + className;
		}
	},
	hasClass: function(el, className) {
		return el.className && new RegExp('(^|\\s)' + className + '(\\s|$)').test(el.className);
	},
	getChildByClass: function(parentEl, childClassName) {
		var node = parentEl.firstChild;
		while(node) {
			if( framework.hasClass(node, childClassName) ) {
				return node;
			}
			node = node.nextSibling;
		}
	},
	arraySearch: function(array, value, key) {
		var i = array.length;
		while(i--) {
			if(array[i][key] === value) {
				return i;
			}
		}
		return -1;
	},
	extend: function(o1, o2, preventOverwrite) {
		for (var prop in o2) {
			if (o2.hasOwnProperty(prop)) {
				if(preventOverwrite && o1.hasOwnProperty(prop)) {
					continue;
				}
				o1[prop] = o2[prop];
			}
		}
	},
	easing: {
		sine: {
			out: function(k) {
				return Math.sin(k * (Math.PI / 2));
			},
			inOut: function(k) {
				return - (Math.cos(Math.PI * k) - 1) / 2;
			}
		},
		cubic: {
			out: function(k) {
				return --k * k * k + 1;
			}
		}
		/*
			elastic: {
				out: function ( k ) {

					var s, a = 0.1, p = 0.4;
					if ( k === 0 ) return 0;
					if ( k === 1 ) return 1;
					if ( !a || a < 1 ) { a = 1; s = p / 4; }
					else s = p * Math.asin( 1 / a ) / ( 2 * Math.PI );
					return ( a * Math.pow( 2, - 10 * k) * Math.sin( ( k - s ) * ( 2 * Math.PI ) / p ) + 1 );

				},
			},
			back: {
				out: function ( k ) {
					var s = 1.70158;
					return --k * k * ( ( s + 1 ) * k + s ) + 1;
				}
			}
		*/
	},

	/**
	 *
	 * @return {object}
	 *
	 * {
	 *  raf : request animation frame function
	 *  caf : cancel animation frame function
	 *  transfrom : transform property key (with vendor), or null if not supported
	 *  oldIE : IE8 or below
	 * }
	 *
	 */
	detectFeatures: function() {
		if(framework.features) {
			return framework.features;
		}
		var helperEl = framework.createEl(),
			helperStyle = helperEl.style,
			vendor = '',
			features = {};

		// IE8 and below
		features.oldIE = document.all && !document.addEventListener;

		features.touch = 'ontouchstart' in window;

		if(window.requestAnimationFrame) {
			features.raf = window.requestAnimationFrame;
			features.caf = window.cancelAnimationFrame;
		}

		features.pointerEvent = navigator.pointerEnabled || navigator.msPointerEnabled;

		// fix false-positive detection of old Android in new IE
		// (IE11 ua string contains "Android 4.0")

		if(!features.pointerEvent) {

			var ua = navigator.userAgent;

			// Detect if device is iPhone or iPod and if it's older than iOS 8
			// http://stackoverflow.com/a/14223920
			//
			// This detection is made because of buggy top/bottom toolbars
			// that don't trigger window.resize event.
			// For more info refer to _isFixedPosition variable in core.js

			if (/iP(hone|od)/.test(navigator.platform)) {
				var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
				if(v && v.length > 0) {
					v = parseInt(v[1], 10);
					if(v >= 1 && v < 8 ) {
						features.isOldIOSPhone = true;
					}
				}
			}

			// Detect old Android (before KitKat)
			// due to bugs related to position:fixed
			// http://stackoverflow.com/questions/7184573/pick-up-the-android-version-in-the-browser-by-javascript

			var match = ua.match(/Android\s([0-9\.]*)/);
			var androidversion =  match ? match[1] : 0;
			androidversion = parseFloat(androidversion);
			if(androidversion >= 1 ) {
				if(androidversion < 4.4) {
					features.isOldAndroid = true; // for fixed position bug & performance
				}
				features.androidVersion = androidversion; // for touchend bug
			}
			features.isMobileOpera = /opera mini|opera mobi/i.test(ua);

			// p.s. yes, yes, UA sniffing is bad, propose your solution for above bugs.
		}

		var styleChecks = ['transform', 'perspective', 'animationName'],
			vendors = ['', 'webkit','Moz','ms','O'],
			styleCheckItem,
			styleName;

		for(var i = 0; i < 4; i++) {
			vendor = vendors[i];

			for(var a = 0; a < 3; a++) {
				styleCheckItem = styleChecks[a];

				// uppercase first letter of property name, if vendor is present
				styleName = vendor + (vendor ?
										styleCheckItem.charAt(0).toUpperCase() + styleCheckItem.slice(1) :
										styleCheckItem);

				if(!features[styleCheckItem] && styleName in helperStyle ) {
					features[styleCheckItem] = styleName;
				}
			}

			if(vendor && !features.raf) {
				vendor = vendor.toLowerCase();
				features.raf = window[vendor+'RequestAnimationFrame'];
				if(features.raf) {
					features.caf = window[vendor+'CancelAnimationFrame'] ||
									window[vendor+'CancelRequestAnimationFrame'];
				}
			}
		}

		if(!features.raf) {
			var lastTime = 0;
			features.raf = function(fn) {
				var currTime = new Date().getTime();
				var timeToCall = Math.max(0, 16 - (currTime - lastTime));
				var id = window.setTimeout(function() { fn(currTime + timeToCall); }, timeToCall);
				lastTime = currTime + timeToCall;
				return id;
			};
			features.caf = function(id) { clearTimeout(id); };
		}

		// Detect SVG support
		features.svg = !!document.createElementNS &&
						!!document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect;

		framework.features = features;

		return features;
	}
};

framework.detectFeatures();


// Override addEventListener for old versions of IE
if(framework.features.oldIE) {

	framework.bind = function(target, type, listener, unbind) {

		type = type.split(' ');

		var methodName = (unbind ? 'detach' : 'attach') + 'Event',
			evName,
			_handleEv = function() {
				listener.handleEvent.call(listener);
			};

		for(var i = 0; i < type.length; i++) {
			evName = type[i];
			if(evName) {

				if(typeof listener === 'object' && listener.handleEvent) {
					if(!unbind) {
						listener['oldIE' + evName] = _handleEv;
					} else {
						if(!listener['oldIE' + evName]) {
							return false;
						}
					}

					target[methodName]( 'on' + evName, listener['oldIE' + evName]);
				} else {
					target[methodName]( 'on' + evName, listener);
				}

			}
		}
	};

}

/*>>framework-bridge*/

/*>>core*/
//function(template, UiClass, items, options)

var self = this;

/**
 * Static vars, don't change unless you know what you're doing.
 */
var DOUBLE_TAP_RADIUS = 25,
	NUM_HOLDERS = 3;

/**
 * Options
 */
var _options = {
	allowPanToNext:true,
	spacing: 0.12,	bgOpacity: 1,
	mouseUsed: false,
	loop: true,
	pinchToClose: true,
	closeOnScroll: true,
	animatedCloseOnScroll: true,
	showCaption: true,
	closeOnVerticalDrag: true,
	verticalDragRange: 0.75,
	hideAnimationDuration: 222,
	showAnimationDuration: 222,
	showHideOpacity: false,
	focus: true,
	escKey: true,
	arrowKeys: true,
	mainScrollEndFriction: 0.35,
	panEndFriction: 0.35,
	isClickableElement: function(el) {
        return el.tagName === 'A';
    },
    getDoubleTapZoom: function(isMouseClick, item) {
    	if(isMouseClick) {
    		return 1;
    	} else {
    		return item.initialZoomLevel < 0.7 ? 1 : 1.33;
    	}
    },
    maxSpreadZoom: 1.33,
	modal: true,

	// not fully implemented yet
	scaleMode: 'fit' // TODO
};
framework.extend(_options, options);


/**
 * Private helper variables & functions
 */

var _lastScrollPosition = null;

var _scrollPositionListener = function(){

	var currentScroll = framework.getScrollY();
	if ( _lastScrollPosition === null){
		_lastScrollPosition = currentScroll;
	}

	if ( !_listeningToScrollWheel ) {

		_scrollDelta = _scrollDelta+(currentScroll-_lastScrollPosition);
		_lastScrollPosition = currentScroll;

		if( _currZoomLevel <= self.currItem.fitRatio && !_touchScrollDrag ){
			if( _options.modal ) {
				if (!_options.animatedCloseOnScroll || _numAnimations || _isDragging) {
					_scrollDelta = 0;
				} else if(_transformKey && Math.abs(_scrollDelta) > 0 && !_isScrollAnimating) {
					_stopScrollUpdateLoop();
					_startScrollAnimation();
				}

				if(_endScrollTimeout) {
					clearTimeout(_endScrollTimeout);
				}

				if ( _options.animatedCloseOnScroll ){

				}
				_endScrollTimeout = setTimeout(function(){
					_stopScrollUpdateLoop();
					_resetScrollPosition();
				}, 200)
			}


		}
	}	
};

var _getEmptyPoint = function() {
		return {x:0,y:0};
	};

var _getEmptyPointWithRotation = function() {
		return {x:0,y:0, rotation: 0};
	};

var _isOpen,
	_isDestroying,
	_closedByScroll,
	_currentItemIndex,
	_containerStyle,
	_containerShiftIndex,
	_currPanDist = _getEmptyPoint(),
	_startPanOffset = _getEmptyPointWithRotation(),
	_panOffset = _getEmptyPointWithRotation(),
	_upMoveEvents, // drag move, drag end & drag cancel events array
	_downEvents, // drag start events array
	_globalEventHandlers,
	_viewportSize = {},
	_viewportPadSize = {},
	_currZoomLevel,
	_startZoomLevel,
	_translatePrefix,
	_translateSufix,
	_updateSizeInterval,
	_itemsNeedUpdate,
	_currPositionIndex = 0,
	_offset = {},
	_slideSize = _getEmptyPoint(), // size of slide area, including spacing
	_itemHolders,
	_prevItemIndex,
	_indexDiff = 0, // difference of indexes since last content update
	_dragStartEvent,
	_dragMoveEvent,
	_dragEndEvent,
	_dragCancelEvent,
	_transformKey,
	_pointerEventEnabled,
	_isFixedPosition = true,
	_likelyTouchDevice,
	_modules = [],
	_requestAF,
	_cancelAF,
	_initalClassName,
	_initalWindowScrollY,
	_oldIE,
	_currentWindowScrollY,
	_features,
	_windowVisibleSize = {},
	_renderMaxResolution = false,
	_orientationChangeTimeout,

	_isScrollAnimating = false,



	// Registers PhotoSWipe module (History, Controller ...)
	_registerModule = function(name, module) {
		framework.extend(self, module.publicMethods);
		_modules.push(name);
	},

	_getLoopedId = function(index) {
		var numSlides = _getNumItems();
		if(index > numSlides - 1) {
			return index - numSlides;
		} else  if(index < 0) {
			return numSlides + index;
		}
		return index;
	},

	// Micro bind/trigger
	_listeners = {},
	_listen = function(name, fn) {
		if(!_listeners[name]) {
			_listeners[name] = [];
		}
		return _listeners[name].push(fn);
	},
	_shout = function(name) {
		var listeners = _listeners[name];

		if(listeners) {
			var args = Array.prototype.slice.call(arguments);
			args.shift();

			for(var i = 0; i < listeners.length; i++) {
				listeners[i].apply(self, args);
			}
		}
	},

	_getCurrentTime = function() {
		return new Date().getTime();
	},
	_applyBgOpacity = function(opacity) {
		_bgOpacity = opacity;
		self.bg.style.opacity = opacity * _options.bgOpacity;
	},

	_applyZoomTransform = function(styleObj,x,y,zoom,item, rotation) {
		if(!_renderMaxResolution || (item && item !== self.currItem) ) {
			zoom = zoom / (item ? item.fitRatio : self.currItem.fitRatio);
		}

		y = y+_viewportPadSize.top;
		styleObj[_transformKey] = _translatePrefix + x + 'px, ' + y + 'px' + _translateSufix + ' scale(' + zoom + ') rotateZ('+rotation+'rad)';
	},
	_applyCurrentZoomPan = function( allowRenderResolution ) {
		if(_currZoomElementStyle) {

			if(allowRenderResolution) {
				if(_currZoomLevel > self.currItem.fitRatio) {
					if(!_renderMaxResolution) {
						_setImageSize(self.currItem, false, true);
						_renderMaxResolution = true;
					}
				} else {
					if(_renderMaxResolution) {
						_setImageSize(self.currItem);
						_renderMaxResolution = false;
					}
				}
			}

			_applyZoomTransform(_currZoomElementStyle, _panOffset.x, _panOffset.y, _currZoomLevel, null, _panOffset.rotation);
		}
	},
	_applyZoomPanToItem = function(item) {
		if(item.container) {

			_applyZoomTransform(item.container.style,
								item.initialPosition.x,
								item.initialPosition.y,
								item.initialZoomLevel,
								item, 0);
		}
	},
	_setTranslateX = function(x, y, elStyle) {
		elStyle[_transformKey] = _translatePrefix + x + 'px, '+y+'px' + _translateSufix;
	},
	_moveMainScroll = function(x, dragging) {
		if(!_options.loop && dragging) {
			var newSlideIndexOffset = _currentItemIndex + (_slideSize.x * _currPositionIndex - x) / _slideSize.x,
				delta = x - _mainScrollPos.x;

			if( (newSlideIndexOffset < 0 && delta > 0) ||
				(newSlideIndexOffset >= _getNumItems() - 1 && delta < 0) ) {
				x = _mainScrollPos.x + delta * _options.mainScrollEndFriction;
			}
		}


		_mainScrollPos.x = x;
		_setTranslateX(x, 0, _containerStyle);
	},
	_calculatePanOffset = function(axis, zoomLevel) {

		var m = _midZoomPoint[axis] - _offset[axis];
		return _startPanOffset[axis] + _currPanDist[axis] + m - m * ( zoomLevel / _startZoomLevel );
	},

	_equalizePoints = function(p1, p2) {

		p1.x = p2.x;
		p1.y = p2.y;
		if(p2.id) {
			p1.id = p2.id;
		}
	},
	_roundPoint = function(p) {
		p.x = Math.round(p.x);
		p.y = Math.round(p.y);
	},

	_mouseMoveTimeout = null,
	_onFirstMouseMove = function() {
		// Wait until mouse move event is fired at least twice during 100ms
		// We do this, because some mobile browsers trigger it on touchstart
		if(_mouseMoveTimeout ) {
			framework.unbind(document, 'mousemove', _onFirstMouseMove);
			framework.addClass(template, 'quick-view-has-mouse');
			_options.mouseUsed = true;
			_shout('mouseUsed');
		}
		_mouseMoveTimeout = setTimeout(function() {
			_mouseMoveTimeout = null;
		}, 100);
	},

	_bindEvents = function() {
		framework.bind(document, 'keydown', self);

		if(_features.transform) {
			// don't bind click event in browsers that don't support transform (mostly IE8)
			framework.bind(self.scrollWrap, 'click', self);
		}


		if(!_options.mouseUsed) {
			framework.bind(document, 'mousemove', _onFirstMouseMove);
		}

		framework.bind(window, 'resize scroll orientationchange', self);

		_shout('bindEvents');
	},

	_unbindEvents = function() {
		framework.unbind(window, 'resize scroll orientationchange', self);
		framework.unbind(window, 'scroll', _globalEventHandlers.scroll);
		framework.unbind(document, 'keydown', self);
		framework.unbind(document, 'mousemove', _onFirstMouseMove);

		if(_features.transform) {
			framework.unbind(self.scrollWrap, 'click', self);
		}

		if(_isDragging) {
			framework.unbind(window, _upMoveEvents, self);
		}

		clearTimeout(_orientationChangeTimeout);

		_shout('unbindEvents');
	},

	_calculatePanBounds = function(zoomLevel, update) {
		var bounds = _calculateItemSize( self.currItem, _viewportSize, zoomLevel );
		if(update) {
			_currPanBounds = bounds;
		}
		return bounds;
	},

	_getMinZoomLevel = function(item) {
		if(!item) {
			item = self.currItem;
		}
		return item.initialZoomLevel;
	},
	_getMaxZoomLevel = function(item) {
		if(!item) {
			item = self.currItem;
		}
		return item.w > 0 ? _options.maxSpreadZoom : 1;
	},

	// Return true if offset is out of the bounds
	_modifyDestPanOffset = function(axis, destPanBounds, destPanOffset, destZoomLevel) {
		if(destZoomLevel === self.currItem.initialZoomLevel) {
			destPanOffset[axis] = self.currItem.initialPosition[axis];
			return true;
		} else {
			destPanOffset[axis] = _calculatePanOffset(axis, destZoomLevel);

			if(destPanOffset[axis] > destPanBounds.min[axis]) {
				destPanOffset[axis] = destPanBounds.min[axis];
				return true;
			} else if(destPanOffset[axis] < destPanBounds.max[axis] ) {
				destPanOffset[axis] = destPanBounds.max[axis];
				return true;
			}
		}
		return false;
	},

	_setupTransforms = function() {

		if(_transformKey) {
			// setup 3d transforms
			var allow3dTransform = _features.perspective && !_likelyTouchDevice;
			_translatePrefix = 'translate' + (allow3dTransform ? '3d(' : '(');
			_translateSufix = _features.perspective ? ', 0px)' : ')';
			return;
		}

		// Override zoom/pan/move functions in case old browser is used (most likely IE)
		// (so they use left/top/width/height, instead of CSS transform)

		_transformKey = 'left';
		framework.addClass(template, 'quick-view-ie');

		_setTranslateX = function(x, elStyle) {
			elStyle.left = x + 'px';
		};
		_applyZoomPanToItem = function(item) {

			var zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio,
				s = item.container.style,
				w = zoomRatio * item.w,
				h = zoomRatio * item.h;

			s.width = w + 'px';
			s.height = h + 'px';
			s.left = item.initialPosition.x + 'px';
			s.top = item.initialPosition.y + 'px';

		};
		_applyCurrentZoomPan = function() {

			if(_currZoomElementStyle) {

				var s = _currZoomElementStyle,
					item = self.currItem,
					zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio,
					w = zoomRatio * item.w,
					h = zoomRatio * item.h;

				s.width = w + 'px';
				s.height = h + 'px';
				s.left = _panOffset.x + 'px';
				s.top = _panOffset.y + 'px';
			}

		};
	},

	_onKeyDown = function(e) {
		var keydownAction = '';
		if(_options.escKey && e.keyCode === 27) {
			keydownAction = 'close';
		} else if(_options.arrowKeys) {
			if(e.keyCode === 37) {
				keydownAction = 'prev';
			} else if(e.keyCode === 39) {
				keydownAction = 'next';
			}
		}

		if (e.keyCode === 32) {
			e.preventDefault();
			e.stopImmediatePropagation();
			keydownAction = 'close';
		}

		if(keydownAction) {
			// don't do anything if special key pressed to prevent from overriding default browser actions
			// e.g. in Chrome on Mac cmd+arrow-left returns to previous page
			if( !e.ctrlKey && !e.altKey && !e.shiftKey && !e.metaKey ) {
				if(e.preventDefault) {
					e.preventDefault();
				} else {
					e.returnValue = false;
				}
				self[keydownAction]();
			}
		}
	},

	_onGlobalClick = function(e) {
		if(!e) {
			return;
		}

		// don't allow click event to pass through when triggering after drag or some other gesture
		if(_moved || _zoomStarted || _mainScrollAnimating || _verticalDragInitiated) {
			e.preventDefault();
			e.stopPropagation();
		}
	},

	_updatePageScrollOffset = function() {
		self.setScrollOffset(0, framework.getScrollY());
	};


if(!helpers.isServer) {
	window.addEventListener('scroll', _scrollPositionListener);
}


// Micro animation engine
var _animations = {},
	_numAnimations = 0,
	_stopAnimation = function(name) {
		if(_animations[name]) {
			if(_animations[name].raf) {
				_cancelAF( _animations[name].raf );
			}
			_numAnimations--;
			delete _animations[name];
		}
	},
	_registerStartAnimation = function(name) {
		if(_animations[name]) {
			_stopAnimation(name);
		}
		if(!_animations[name]) {
			_numAnimations++;
			_animations[name] = {};
		}
	},
	_stopAllAnimations = function() {
		for (var prop in _animations) {

			if( _animations.hasOwnProperty( prop ) ) {
				_stopAnimation(prop);
			}

		}
	},
	_animateProp = function(name, b, endProp, d, easingFn, onUpdate, onComplete) {
		var startAnimTime = _getCurrentTime(), t;
		_registerStartAnimation(name);

		var animloop = function(){
			if ( _animations[name] ) {

				t = _getCurrentTime() - startAnimTime; // time diff
				//b - beginning (start prop)
				//d - anim duration

				if ( t >= d ) {
					_stopAnimation(name);
					onUpdate(endProp);
					if(onComplete) {
						onComplete();
					}
					return;
				}
				onUpdate( (endProp - b) * easingFn(t/d) + b );

				_animations[name].raf = _requestAF(animloop);
			}
		};
		animloop();
	};



var publicMethods = {

	// make a few local variables and functions public
	shout: _shout,
	listen: _listen,
	viewportSize: _viewportSize,
	options: _options,

	isMainScrollAnimating: function() {
		return _mainScrollAnimating;
	},
	getZoomLevel: function() {
		return _currZoomLevel;
	},
	getCurrentIndex: function() {
		return _currentItemIndex;
	},
	isDragging: function() {
		return _isDragging;
	},
	isZooming: function() {
		return _isZooming;
	},
	setScrollOffset: function(x,y) {
		_offset.x = x;
		_currentWindowScrollY = _offset.y = y;
		_shout('updateScrollOffset', _offset);
	},
	applyZoomPan: function(zoomLevel,panX,panY,allowRenderResolution) {

		_panOffset.x = panX;
		_panOffset.y = panY;
		_currZoomLevel = zoomLevel;
		_applyCurrentZoomPan( allowRenderResolution );
	},

	init: function() {

		if(_isOpen || _isDestroying) {
			return;
		}

		eventProxy('init', self);

		var i;

		self.framework = framework; // basic functionality
		self.template = template; // root DOM element of PhotoSwipe
		self.bg = framework.getChildByClass(template, 'quick-view-bg');

		self.captionPositioner = framework.getChildByClass(template,'quick-view-caption-positioner')

		self.captionWrapper = framework.getChildByClass(self.captionPositioner,'quick-view-caption-wrapper')

		self.caption = framework.getChildByClass(self.captionWrapper, 'quick-view-caption');

		_initalClassName = template.className;
		_isOpen = true;

		_features = framework.detectFeatures();
		_requestAF = _features.raf;
		_cancelAF = _features.caf;
		_transformKey = _features.transform;
		_oldIE = _features.oldIE;

		self.scrollWrap = framework.getChildByClass(template, 'quick-view-scroll-wrap');
		self.container = framework.getChildByClass(self.scrollWrap, 'quick-view-container');

		_containerStyle = self.container.style; // for fast access

		// Objects that hold slides (there are only 3 in DOM)
		self.itemHolders = _itemHolders = [
			{el:self.container.children[0] , wrap:0, index: -1},
			{el:self.container.children[1] , wrap:0, index: -1},
			{el:self.container.children[2] , wrap:0, index: -1}
		];

		// hide nearby item holders until initial zoom animation finishes (to avoid extra Paints)
		_itemHolders[0].el.style.display = _itemHolders[2].el.style.display = 'none';

		_setupTransforms();

		// Setup global events
		_globalEventHandlers = {
			resize: self.updateSize,

			// Fixes: iOS 10.3 resize event
			// does not update scrollWrap.clientWidth instantly after resize
			// https://github.com/dimsemenov/PhotoSwipe/issues/1315
			orientationchange: function() {
				clearTimeout(_orientationChangeTimeout);
				_orientationChangeTimeout = setTimeout(function() {
					if(_viewportSize.x !== self.scrollWrap.clientWidth) {
						self.updateSize();
					}
				}, 500);
			},
			scroll: _updatePageScrollOffset,
			keydown: _onKeyDown,
			click: _onGlobalClick
		};

		// disable show/hide effects on old browsers that don't support CSS animations or transforms,
		// old IOS, Android and Opera mobile. Blackberry seems to work fine, even older models.
		var oldPhone = _features.isOldIOSPhone || _features.isOldAndroid || _features.isMobileOpera;
		if(!_features.animationName || !_features.transform || oldPhone) {
			_options.showAnimationDuration = _options.hideAnimationDuration = 0;
		}

		// init modules
		for(i = 0; i < _modules.length; i++) {
			self['init' + _modules[i]]();
		}
		// init
		if(UiClass) {
			var ui = self.ui = new UiClass(self, framework);
			ui.init();
		}

		_shout('firstUpdate');
		_currentItemIndex = _currentItemIndex || _options.index || 0;
		// validate index
		if( isNaN(_currentItemIndex) || _currentItemIndex < 0 || _currentItemIndex >= _getNumItems() ) {
			_currentItemIndex = 0;
		}

		self.currItem = _getItemAt( _currentItemIndex );

		if(_features.isOldIOSPhone || _features.isOldAndroid) {
			_isFixedPosition = false;
		}

		template.setAttribute('aria-hidden', 'false');
		if(_options.modal) {
			if(!_isFixedPosition) {
				template.style.position = 'absolute';
				template.style.top = framework.getScrollY() + 'px';
			} else {
				template.style.position = 'fixed';
			}
		}

		template.classList.add('quick-view-vertical-align-'+_options.alignVertical)
		template.classList.add('quick-view-horizontal-align-'+_options.alignHorizontal)

		if(_currentWindowScrollY === undefined) {
			_shout('initialLayout');
			_currentWindowScrollY = _initalWindowScrollY = framework.getScrollY();
		}

		// add classes to root element of PhotoSwipe
		var rootClasses = 'quick-view-open ';
		if(_options.mainClass) {
			rootClasses += _options.mainClass + ' ';
		}
		if(_options.showHideOpacity) {
			rootClasses += 'quick-view-animate_opacity ';
		}
		rootClasses += _likelyTouchDevice ? 'quick-view-touch' : 'quick-view-notouch';
		rootClasses += _features.animationName ? ' quick-view-css_animation' : '';
		rootClasses += _features.svg ? ' quick-view-svg' : '';
		framework.addClass(template, rootClasses);

		self.updateSize();

		// initial update
		_containerShiftIndex = -1;
		_indexDiff = null;
		for(i = 0; i < NUM_HOLDERS; i++) {
			_setTranslateX( (i+_containerShiftIndex) * (_slideSize.x)+_viewportPadSize.left, 0, _itemHolders[i].el.style);
		}

		if(!_oldIE) {
			framework.bind(self.scrollWrap, _downEvents, self); // no dragging for old IE
		}

		_listen('initialZoomInEnd', function() {
			self.setContent(_itemHolders[0], _currentItemIndex-1);
			self.setContent(_itemHolders[2], _currentItemIndex+1);

			_itemHolders[0].el.style.display = _itemHolders[2].el.style.display = 'block';

			if(_options.focus) {
				// focus causes layout,
				// which causes lag during the animation,
				// that's why we delay it untill the initial zoom transition ends
				template.focus();
			}

			_bindEvents();
		});

		// set content for center slide (first time)
		self.setContent(_itemHolders[1], _currentItemIndex);

		self.updateCurrItem();

		setTimeout(self.updateCaption, _options.showAnimationDuration +50)
		

		_shout('afterInit', _currentItemIndex);

		eventProxy('after-init', self);

		if(!_isFixedPosition) {

			// On all versions of iOS lower than 8.0, we check size of viewport every second.
			//
			// This is done to detect when Safari top & bottom bars appear,
			// as this action doesn't trigger any events (like resize).
			//
			// On iOS8 they fixed this.
			//
			// 10 Nov 2014: iOS 7 usage ~40%. iOS 8 usage 56%.

			_updateSizeInterval = setInterval(function() {
				if(!_numAnimations && !_isDragging && !_isZooming && (_currZoomLevel === self.currItem.initialZoomLevel)  ) {
					self.updateSize();
				}
			}, 1000);
		}

		framework.addClass(template, 'quick-view-visible');

	},

	// Close the gallery, then destroy it
	close: function() {

		if(!_isOpen) {
			return;
		}

		_isOpen = false;
		_isDestroying = true;
		_shout('close');
		eventProxy('closing', self);
		_unbindEvents();

		_showOrHide(self.currItem, null, true, self.destroy);
	},

	// destroys the gallery (unbinds events, cleans up intervals and timeouts to avoid memory leaks)
	destroy: function() {

		_shout('destroy');
		eventProxy('destroy', self);

		if(_showOrHideTimeout) {
			clearTimeout(_showOrHideTimeout);
		}

		template.setAttribute('aria-hidden', 'true');
		template.className = _initalClassName;

		if(_updateSizeInterval) {
			clearInterval(_updateSizeInterval);
		}

		framework.unbind(self.scrollWrap, _downEvents, self);

		// we unbind scroll event at the end, as closing animation may depend on it
		framework.unbind(window, 'scroll', self);
		window.removeEventListener('scroll', _scrollPositionListener);

		_stopDragUpdateLoop();

		_stopAllAnimations();

		_listeners = null;
	},

	/**
	 * Pan image to position
	 * @param {Number} x
	 * @param {Number} y
	 * @param {Boolean} force Will ignore bounds if set to true.
	 */
	panTo: function(x,y,force) {

		if(!force) {
			if(x > _currPanBounds.min.x) {
				x = _currPanBounds.min.x;
			} else if(x < _currPanBounds.max.x) {
				x = _currPanBounds.max.x;
			}

			if(y > _currPanBounds.min.y) {
				y = _currPanBounds.min.y;
			} else if(y < _currPanBounds.max.y) {
				y = _currPanBounds.max.y;
			}
		}

		_panOffset.x = x;
		_panOffset.y = y;
		_applyCurrentZoomPan();
	},

	handleEvent: function (e) {
		e = e || window.event;
		if(_globalEventHandlers[e.type]) {
			_globalEventHandlers[e.type](e);
		}
	},


	goTo: function(index) {

		index = _getLoopedId(index);

		var diff = index - _currentItemIndex;
		_indexDiff = diff;

		/*var indexShift = _indexDiff;

		if(indexShift === null) {
			indexShift = 0;
		}*/

		//eventProxy('before-slide-change', self, indexShift);

		_currentItemIndex = index;
		self.currItem = _getItemAt( _currentItemIndex );
		_currPositionIndex -= diff;

		_moveMainScroll(_slideSize.x * _currPositionIndex);

		_stopAllAnimations();
		// _listeningToScrollWheel = true;
		_mainScrollAnimating = false;

		self.updateCurrItem();
	},
	next: function() {
		self.goTo( _currentItemIndex + 1);
	},
	prev: function() {
		self.goTo( _currentItemIndex - 1);
	},

	// update current zoom/pan objects
	updateCurrZoomItem: function(emulateSetContent) {


		if(emulateSetContent) {
			_shout('beforeChange', 0);
			eventProxy('before-slide-change', self, 0);
		}

		// itemHolder[1] is center (current) item
		if(_itemHolders[1].el.children.length) {
			var zoomElement = _itemHolders[1].el.children[0];
			if( framework.hasClass(zoomElement, 'quick-view-zoom-wrap') ) {
				_currZoomElementStyle = zoomElement.style;
			} else {
				_currZoomElementStyle = null;
			}
		} else {
			_currZoomElementStyle = null;
		}

		_currPanBounds = self.currItem.bounds;
		_startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;

		_panOffset.x = _currPanBounds.center.x;
		_panOffset.y = _currPanBounds.center.y;

		if(emulateSetContent) {
			_shout('afterChange', _currentItemIndex);
			eventProxy('after-slide-change', self);
		}

		
	},


	invalidateCurrItems: function() {
		_itemsNeedUpdate = true;
		for(var i = 0; i < NUM_HOLDERS; i++) {
			if( _itemHolders[i].item ) {
				_itemHolders[i].item.needsUpdate = true;
			}
		}
	},

	updateCaption: function(){

		if ( self.currItem.caption && _options.showCaption ){
			while(self.caption.childNodes.length > 0){
				self.caption.childNodes[0].parentNode.removeChild(self.caption.childNodes[0]);
			}			

			self.caption.appendChild(self.currItem.caption)

			_setCaptionSize(self.currItem)

			self.caption.classList.remove('hidden');

		} else if ( _options.showCaption) {

			var onCaptionFade = function(){
				while(self.caption.childNodes.length > 0){
					self.caption.childNodes[0].parentNode.removeChild(self.caption.childNodes[0]);
				}

				self.caption.removeEventListener('transitionend', onCaptionFade)
			}

			if ( self.caption.classList.contains('hidden') ){
				onCaptionFade();
			} else {
				self.caption.addEventListener('transitionend', onCaptionFade)
				self.caption.classList.add('hidden');
			}

		}
	},

	updateCurrItem: function(beforeAnimation) {

		if(_indexDiff === 0) {
			return;
		}

		var diffAbs = Math.abs(_indexDiff),
			tempHolder;

		if(beforeAnimation && diffAbs < 2) {
			return;
		}

		self.currItem = _getItemAt( _currentItemIndex );

		_renderMaxResolution = false;

		_shout('beforeChange', _indexDiff);

		var indexShift = _indexDiff;

		if(indexShift === null) {
			indexShift = 0;
		}


		eventProxy('slide-change', self, indexShift);

		if(diffAbs >= NUM_HOLDERS) {
			_containerShiftIndex += _indexDiff + (_indexDiff > 0 ? -NUM_HOLDERS : NUM_HOLDERS);
			diffAbs = NUM_HOLDERS;
		}

		for(var i = 0; i < diffAbs; i++) {
			if(_indexDiff > 0) {
				tempHolder = _itemHolders.shift();
				_itemHolders[NUM_HOLDERS-1] = tempHolder; // move first to last

				_containerShiftIndex++;

				_setTranslateX( (_containerShiftIndex+2) * (_slideSize.x)+_viewportPadSize.left,0, tempHolder.el.style);
				self.setContent(tempHolder, _currentItemIndex - diffAbs + i + 1 + 1);
			} else {
				tempHolder = _itemHolders.pop();
				_itemHolders.unshift( tempHolder ); // move last to first

				_containerShiftIndex--;
				_setTranslateX( _containerShiftIndex * (_slideSize.x)+_viewportPadSize.left, 0, tempHolder.el.style);
				self.setContent(tempHolder, _currentItemIndex + diffAbs - i - 1 - 1);
			}

		}

		// reset zoom/pan on previous item
		if(_currZoomElementStyle && Math.abs(_indexDiff) === 1) {

			var prevItem = _getItemAt(_prevItemIndex);
			if(prevItem.initialZoomLevel !== _currZoomLevel) {
				_calculateItemSize(prevItem , _viewportSize );
				_setImageSize(prevItem);
				_applyZoomPanToItem( prevItem );
			}

		}


		var lastHolderIndex = 1+-_indexDiff;

		var holder = _itemHolders[lastHolderIndex];


		// reset diff after update
		_indexDiff = 0;

		self.updateCurrZoomItem();

		// wait for initial layout to show the caption
		if ( _prevItemIndex !== undefined){
			self.updateCaption();
		}


		var prevItem = _getItemAt( _prevItemIndex );

		var prevMediaItem = prevItem?.container?.querySelector('media-item');
		if( prevMediaItem ){
			prevMediaItem.removeAttribute('autoplay');
			prevMediaItem.pause?.();
			// prevMediaItem.setCurrentTime?.(0);			
		}

		var currentItem = _getItemAt( _currentItemIndex );

		var currentMediaItem = currentItem?.container?.querySelector('media-item');
		if( currentMediaItem ){
			dispatch(currentMediaItem, 'lazyLoadIntersectionChange', {
				visible: true,
				position: 'inside',
			}, {
				bubbles: false
			});

			dispatch(currentMediaItem, 'viewportIntersectionChange', {
				visible: true,
				position: 'inside',
			}, {
				bubbles: false
			});
			if( currentItem.autoplay){
				
				currentMediaItem?.play?.();
			}		
		}

		_prevItemIndex = _currentItemIndex;
					
		_shout('afterChange', _currentItemIndex);

	},



	updateSize: function(force) {

		if(!_isFixedPosition && _options.modal) {
			var windowScrollY = framework.getScrollY();
			if(_currentWindowScrollY !== windowScrollY) {
				template.style.top = windowScrollY + 'px';
				_currentWindowScrollY = windowScrollY;
			}
			if(!force && _windowVisibleSize.x === window.innerWidth && _windowVisibleSize.y === window.innerHeight) {
				return;
			}
			_windowVisibleSize.x = window.innerWidth;
			_windowVisibleSize.y = window.innerHeight;

			//template.style.width = _windowVisibleSize.x + 'px';
			template.style.height = _windowVisibleSize.y + 'px';
		}

		var pswpStyle = window.getComputedStyle(self.template);

		var xPadLeft = (
			parseFloat(pswpStyle.getPropertyValue('padding-left'))+
			parseFloat(pswpStyle.getPropertyValue('border-left-width'))
		)

		var marginLeft = parseFloat(pswpStyle.getPropertyValue('margin-left'));

		var xPadRight = (
			parseFloat(pswpStyle.getPropertyValue('padding-right'))+
			parseFloat(pswpStyle.getPropertyValue('border-right-width'))
		)

		var marginRight = parseFloat(pswpStyle.getPropertyValue('margin-right'));

		var yPadTop = (
			parseFloat(pswpStyle.getPropertyValue('padding-top'))+
			parseFloat(pswpStyle.getPropertyValue('border-top-width'))
		)

		var marginTop = parseFloat(pswpStyle.getPropertyValue('margin-top'));

		var yPadBottom = (
			parseFloat(pswpStyle.getPropertyValue('padding-bottom'))+
			parseFloat(pswpStyle.getPropertyValue('border-bottom-width'))
		)

		var marginBottom = parseFloat(pswpStyle.getPropertyValue('margin-bottom'));


		const vertClass = 'quick-view-vertical-align-'+_options.alignVertical;
		const horizClass = 'quick-view-horizontal-align-'+_options.alignHorizontal;


		if( vertClass !== 'quick-view-vertical-align-center' ){
			template.classList.remove('quick-view-vertical-align-center')	
		}

		if( vertClass !== 'quick-view-vertical-align-top' ){
			template.classList.remove('quick-view-vertical-align-top')	
		}

		if( vertClass !== 'quick-view-vertical-align-bottom' ){
			template.classList.remove('quick-view-vertical-align-bottom')	
		}

		if( horizClass !== 'quick-view-horizontal-align-center' ){
			template.classList.remove('quick-view-horizontal-align-center')	
		}

		if( horizClass !== 'quick-view-horizontal-align-left' ){
			template.classList.remove('quick-view-horizontal-align-left')	
		}

		if( horizClass !== 'quick-view-horizontal-align-right' ){
			template.classList.remove('quick-view-horizontal-align-right')	
		}

		template.classList.add(vertClass)
		template.classList.add(horizClass)


		_viewportPadSize.top = yPadTop;
		_viewportPadSize.left = xPadLeft;
		_viewportPadSize.bottom = yPadBottom;
		_viewportPadSize.right = xPadRight;
		_viewportPadSize.marginTop = marginTop;
		_viewportPadSize.marginLeft = marginLeft;
		_viewportPadSize.marginBottom = marginBottom;
		_viewportPadSize.marginRight = marginRight;

		var scrollWrapRect = self.scrollWrap.getBoundingClientRect();
		_viewportSize.x = scrollWrapRect.width;
		_viewportSize.y = scrollWrapRect.height

		_updatePageScrollOffset();

		_slideSize.x = _viewportSize.x + _viewportSize.x * _options.spacing;
		_slideSize.y = _viewportSize.y;

		_moveMainScroll(_slideSize.x * _currPositionIndex);

		_shout('beforeResize'); // even may be used for example to switch image sources


		// don't re-calculate size on inital size update
		if(_containerShiftIndex !== undefined) {

			var holder,
				item,
				hIndex;

			for(var i = 0; i < NUM_HOLDERS; i++) {
				holder = _itemHolders[i];

				_setTranslateX( (i+_containerShiftIndex) * (_slideSize.x)+_viewportPadSize.left, 0, holder.el.style);

				hIndex = _currentItemIndex+i-1;

				if(_options.loop && _getNumItems() > 2) {
					hIndex = _getLoopedId(hIndex);
				}

				// update zoom level on items and refresh source (if needsUpdate)
				item = _getItemAt( hIndex );

				// re-render gallery item if `needsUpdate`,
				// or doesn't have `bounds` (entirely new slide object)
				if( item && (_itemsNeedUpdate || item.needsUpdate || !item.bounds) ) {

					self.cleanSlide( item );

					self.setContent( holder, hIndex );

					// if "center" slide
					if(i === 1) {
						self.currItem = item;
						self.updateCurrZoomItem(true);
					}

					item.needsUpdate = false;

				} else if(holder.index === -1 && hIndex >= 0) {
					// add content first time
					self.setContent( holder, hIndex );
				}

				if(item && item.container) {
					_calculateItemSize(item, _viewportSize);
					_setImageSize(item);
					_applyZoomPanToItem( item );
				}

			}
			_itemsNeedUpdate = false;
		}

		_startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;
		_currPanBounds = self.currItem.bounds;

		if(_currPanBounds) {
			_panOffset.x = _currPanBounds.center.x;
			_panOffset.y = _currPanBounds.center.y;
			_applyCurrentZoomPan( true );
		}

		_shout('resize');
	},

	// Zoom current item to
	zoomTo: function(destZoomLevel, centerPoint, speed, easingFn, updateFn) {
		/*
			if(destZoomLevel === 'fit') {
				destZoomLevel = self.currItem.fitRatio;
			} else if(destZoomLevel === 'fill') {
				destZoomLevel = self.currItem.fillRatio;
			}
		*/
		if(centerPoint) {
			_startZoomLevel = _currZoomLevel;
			_midZoomPoint.x = Math.abs(centerPoint.x) - _panOffset.x ;
			_midZoomPoint.y = Math.abs(centerPoint.y) - _panOffset.y ;
			_equalizePoints(_startPanOffset, _panOffset);
		}

		var destPanBounds = _calculatePanBounds(destZoomLevel, false),
			destPanOffset = {};

		_modifyDestPanOffset('x', destPanBounds, destPanOffset, destZoomLevel);
		_modifyDestPanOffset('y', destPanBounds, destPanOffset, destZoomLevel);

		var initialZoomLevel = _currZoomLevel;
		var initialPanOffset = {
			x: _panOffset.x,
			y: _panOffset.y
		};

		_roundPoint(destPanOffset);

		var onUpdate = function(now) {
			if(now === 1) {
				_currZoomLevel = destZoomLevel;
				_panOffset.x = destPanOffset.x;
				_panOffset.y = destPanOffset.y;

				// hide caption if zooming to non-fitratio
				if ( self.currItem.caption &&  _options.showCaption) {
					if ( Math.abs(_currZoomLevel-self.currItem.fitRatio) > .01  ){
						self.caption.classList.add('hidden')
					} else {
						self.caption.classList.remove('hidden')					
					}
				}

			} else {
				_currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel;
				_panOffset.x = (destPanOffset.x - initialPanOffset.x) * now + initialPanOffset.x;
				_panOffset.y = (destPanOffset.y - initialPanOffset.y) * now + initialPanOffset.y;
			}

			if(updateFn) {
				updateFn(now);
			}

			_applyCurrentZoomPan( now === 1 );
		};

		if(speed) {
			_animateProp('customZoomTo', 0, 1, speed, easingFn || framework.easing.sine.inOut, onUpdate);
		} else {
			onUpdate(1);
		}
	}


};


/*>>core*/

/*>>gestures*/
/**
 * Mouse/touch/pointer event handlers.
 *
 * separated from @core.js for readability
 */

var MIN_SWIPE_DISTANCE = 30,
	DIRECTION_CHECK_OFFSET = 10; // amount of pixels to drag to determine direction of swipe

var _gestureStartTime,
	_gestureCheckSpeedTime,

	// pool of objects that are used during dragging of zooming
	p = {}, // first point
	p2 = {}, // second point (for zoom gesture)
	delta = {},
	_currPoint = {},
	_startPoint = {},
	_currPointers = [],
	_startMainScrollPos = {},
	_releaseAnimData,
	_posPoints = [], // array of points during dragging, used to determine type of gesture
	_tempPoint = {},

	_isZoomingIn,
	_verticalDragInitiated,
	_oldAndroidTouchEndTimeout,
	_currZoomedItemIndex = 0,
	_centerPoint = _getEmptyPoint(),
	_lastReleaseTime = 0,
	_isDragging, // at least one pointer is down
	_isMultitouch, // at least two _pointers are down
	_zoomStarted, // zoom level changed during zoom gesture
	_moved,
	_dragAnimFrame,
	_mainScrollShifted,
	_currentPoints, // array of current touch points
	_isZooming,
	_currPointsDistance,
	_startPointsDistance,
	_currPanBounds,
	_mainScrollPos = _getEmptyPoint(),
	_currZoomElementStyle,
	_mainScrollAnimating, // true, if animation after swipe gesture is running
	_midZoomPoint = _getEmptyPoint(),
	_currCenterPoint = _getEmptyPoint(),
	_direction,
	_isFirstMove,
	_opacityChanged,
	_bgOpacity,
	_wasOverInitialZoom,

	_isEqualPoints = function(p1, p2) {
		return p1.x === p2.x && p1.y === p2.y;
	},
	_isNearbyPoints = function(touch0, touch1) {
		return Math.abs(touch0.x - touch1.x) < DOUBLE_TAP_RADIUS && Math.abs(touch0.y - touch1.y) < DOUBLE_TAP_RADIUS;
	},
	_calculatePointsDistance = function(p1, p2) {
		_tempPoint.x = Math.abs( p1.x - p2.x );
		_tempPoint.y = Math.abs( p1.y - p2.y );
		return Math.sqrt(_tempPoint.x * _tempPoint.x + _tempPoint.y * _tempPoint.y);
	},
	_stopDragUpdateLoop = function() {
		if(_dragAnimFrame) {
			_cancelAF(_dragAnimFrame);
			_dragAnimFrame = null;
		}
	},
	_dragUpdateLoop = function() {
		if(_isDragging) {
			_dragAnimFrame = _requestAF(_dragUpdateLoop);
			_renderMovement();
		}
	},
	_canPan = function() {
		return !(_options.scaleMode === 'fit' && _currZoomLevel ===  self.currItem.initialZoomLevel);
	},

	// find the closest parent DOM element
	_closestElement = function(el, fn) {
	  	if(!el || el === document) {
	  		return false;
	  	}

	  	// don't search elements above pswp__scroll-wrap
	  	if(el.getAttribute('class') && el.getAttribute('class').indexOf('quick-view-scroll-wrap') > -1 ) {
	  		return false;
	  	}

	  	if( fn(el) ) {
	  		return el;
	  	}

	  	return _closestElement(el.parentNode, fn);
	},

	_preventObj = {},
	_preventDefaultEventBehaviour = function(e, isDown) {
	    _preventObj.prevent = !_closestElement(e.target, _options.isClickableElement);

		_shout('preventDragEvent', e, isDown, _preventObj);
		return _preventObj.prevent;

	},
	_convertTouchToPoint = function(touch, p) {
		p.x = touch.pageX+-_viewportPadSize.left+-_viewportPadSize.marginLeft;
		p.y = touch.pageY+-_viewportPadSize.top+-_viewportPadSize.marginTop;
		p.clientY = touch.clientY;
		p.id = touch.identifier;
		return p;
	},
	_findCenterOfPoints = function(p1, p2, pCenter) {
		pCenter.x = (p1.x + p2.x) * 0.5;
		pCenter.y = (p1.y + p2.y) * 0.5;
	},
	_pushPosPoint = function(time, x, y) {
		if(time - _gestureCheckSpeedTime > 50) {
			var o = _posPoints.length > 2 ? _posPoints.shift() : {};
			o.x = x;
			o.y = y;
			_posPoints.push(o);
			_gestureCheckSpeedTime = time;
		}
	},

	_calculateVerticalDragOpacityRatio = function() {
		var yOffset = _panOffset.y - self.currItem.initialPosition.y; // difference between initial and current position

		return Math.min(1.2 -  Math.abs( yOffset / (_viewportSize.y / 2)  ), 1);
	},


	// points pool, reused during touch events
	_ePoint1 = {},
	_ePoint2 = {},
	_tempPointsArr = [],
	_tempCounter,
	_getTouchPoints = function(e) {
		// clean up previous points, without recreating array
		while(_tempPointsArr.length > 0) {
			_tempPointsArr.pop();
		}

		if(!_pointerEventEnabled) {
			if(e.type.indexOf('touch') > -1) {

				if(e.touches && e.touches.length > 0) {
					_tempPointsArr[0] = _convertTouchToPoint(e.touches[0], _ePoint1);
					if(e.touches.length > 1) {
						_tempPointsArr[1] = _convertTouchToPoint(e.touches[1], _ePoint2);
					}
				}

			} else {
				_ePoint1.x = e.pageX;
				_ePoint1.y = e.pageY;
				_ePoint1.clientY = e.clientY;
				_ePoint1.id = '';
				_tempPointsArr[0] = _ePoint1;//_ePoint1;
			}
		} else {
			_tempCounter = 0;
			// we can use forEach, as pointer events are supported only in modern browsers
			_currPointers.forEach(function(p) {
				if(_tempCounter === 0) {
					_tempPointsArr[0] = p;
				} else if(_tempCounter === 1) {
					_tempPointsArr[1] = p;
				}
				_tempCounter++;

			});
		}
		return _tempPointsArr;
	},

	_panOrMoveMainScroll = function(axis, delta) {

		var panFriction,
			overDiff = 0,
			newOffset = _panOffset[axis] + delta[axis],
			startOverDiff,
			dir = delta[axis] > 0,
			newMainScrollPosition = _mainScrollPos.x + delta.x,
			mainScrollDiff = _mainScrollPos.x - _startMainScrollPos.x,
			newPanPos,
			newMainScrollPos;

		// calculate fdistance over the bounds and friction
		if(newOffset > _currPanBounds.min[axis] || newOffset < _currPanBounds.max[axis]) {
			panFriction = _options.panEndFriction;
			// Linear increasing of friction, so at 1/4 of viewport it's at max value.
			// Looks not as nice as was expected. Left for history.
			// panFriction = (1 - (_panOffset[axis] + delta[axis] + panBounds.min[axis]) / (_viewportSize[axis] / 4) );
		} else {
			panFriction = 1;
		}

		newOffset = _panOffset[axis] + delta[axis] * panFriction;

		// move main scroll or start panning
		if(_options.allowPanToNext || _currZoomLevel === self.currItem.initialZoomLevel) {


			if(!_currZoomElementStyle) {

				newMainScrollPos = newMainScrollPosition;

			} else if(_direction === 'h' && axis === 'x' && !_zoomStarted ) {

				if(dir) {
					if(newOffset > _currPanBounds.min[axis]) {
						panFriction = _options.panEndFriction;
						overDiff = _currPanBounds.min[axis] - newOffset;
						startOverDiff = Math.round(_currPanBounds.min[axis] - _startPanOffset[axis]);
					}

					// drag right
					if( (startOverDiff <= 0 || mainScrollDiff < 0) && _getNumItems() > 1 ) {
						newMainScrollPos = newMainScrollPosition;
						if(mainScrollDiff < 0 && newMainScrollPosition > _startMainScrollPos.x) {
							newMainScrollPos = _startMainScrollPos.x;
						}
					} else {
						if(_currPanBounds.min.x !== _currPanBounds.max.x) {
							newPanPos = newOffset;
						}

					}

				} else {

					if(newOffset < _currPanBounds.max[axis] ) {
						panFriction =_options.panEndFriction;
						overDiff = newOffset - _currPanBounds.max[axis];
						startOverDiff = Math.round(_startPanOffset[axis] - _currPanBounds.max[axis]);
					}

					if( (startOverDiff <= 0 || mainScrollDiff > 0) && _getNumItems() > 1 ) {
						newMainScrollPos = newMainScrollPosition;

						if(mainScrollDiff > 0 && newMainScrollPosition < _startMainScrollPos.x) {
							newMainScrollPos = _startMainScrollPos.x;
						}

					} else {
						if(_currPanBounds.min.x !== _currPanBounds.max.x) {
							newPanPos = newOffset;
						}
					}

				}


				//
			}

			if(axis === 'x') {

				if(newMainScrollPos !== undefined) {
					_moveMainScroll(newMainScrollPos, true);
					if(newMainScrollPos === _startMainScrollPos.x) {
						_mainScrollShifted = false;
					} else {
						_mainScrollShifted = true;
					}
				}

				if(_currPanBounds.min.x !== _currPanBounds.max.x) {
					if(newPanPos !== undefined) {
						_panOffset.x = newPanPos;
					} else if(!_mainScrollShifted) {
						_panOffset.x += delta.x * panFriction;
					}
				}
				return newMainScrollPos !== undefined;
			}

		}

		if(!_mainScrollAnimating) {

			if(!_mainScrollShifted) {
				if(_currZoomLevel > self.currItem.fitRatio) {
					_panOffset[axis] += delta[axis] * panFriction;

				}
			}


		}

	},

	_dragstartTimer = null,

	// Pointerdown/touchstart/mousedown handler
	_onDragStart = function(e) {

		// Allow dragging only via left mouse button.
		// As this handler is not added in IE8 - we ignore e.which
		//
		// http://www.quirksmode.org/js/events_properties.html
		// https://developer.mozilla.org/en-US/docs/Web/API/event.button
		if(e.type === 'mousedown' && e.button > 0  ) {
			return;
		}

		if(_initialZoomRunning) {
			e.preventDefault();
			return;
		}

		if(_oldAndroidTouchEndTimeout && e.type === 'mousedown') {
			return;
		}

		if(_preventDefaultEventBehaviour(e, true)) {
			e.preventDefault();
		}

		_eventType = e.type;

		// make sure that iframes don't capture drags
		_dragstartTimer = setTimeout(function(){
			self.template.classList.add('mouse-down')			
		}, 200);

		_shout('pointerDown');

		if(_pointerEventEnabled) {
			var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
			if(pointerIndex < 0) {
				pointerIndex = _currPointers.length;
			}
			_currPointers[pointerIndex] = {x:e.pageX, y:e.pageY, clientY:e.clientY, id: e.pointerId};
		}



		var startPointsList = _getTouchPoints(e),
			numPoints = startPointsList.length;

		_currentPoints = null;

		_stopAllAnimations();

		// init drag
		if(!_isDragging || numPoints === 1) {

			_isDragging = _isFirstMove = true;
			framework.bind(window, _upMoveEvents, self);

			_isZoomingIn =
				_touchScrollDrag =
				_wasOverInitialZoom =
				_opacityChanged =
				_verticalDragInitiated =
				_mainScrollShifted =
				_moved =
				_isMultitouch =
				_zoomStarted = false;

			_direction = null;
			_dragPositionY = startPointsList[0].y +-_currentWindowScrollY;
			_shout('firstTouchStart', startPointsList);

			_equalizePoints(_startPanOffset, _panOffset);

			_currPanDist.x = _currPanDist.y = 0;
			_equalizePoints(_currPoint, startPointsList[0]);
			_equalizePoints(_startPoint, _currPoint);

			//_equalizePoints(_startMainScrollPos, _mainScrollPos);
			_startMainScrollPos.x = _slideSize.x * _currPositionIndex;

			_posPoints = [{
				x: _currPoint.x,
				y: _currPoint.y
			}];

			_gestureCheckSpeedTime = _gestureStartTime = _getCurrentTime();

			//_mainScrollAnimationEnd(true);
			_calculatePanBounds( _currZoomLevel, true );

			// Start rendering
			_stopDragUpdateLoop();
			_dragUpdateLoop();

		}

		// init zoom
		if(!_isZooming && numPoints > 1 && !_mainScrollAnimating && !_mainScrollShifted) {
			_startZoomLevel = _currZoomLevel;
			_zoomStarted = false; // true if zoom changed at least once

			_isZooming = _isMultitouch = true;
			_currPanDist.y = _currPanDist.x = 0;

			_equalizePoints(_startPanOffset, _panOffset);

			_equalizePoints(p, startPointsList[0]);
			_equalizePoints(p2, startPointsList[1]);

			_findCenterOfPoints(p, p2, _currCenterPoint);

			_midZoomPoint.x = Math.abs(_currCenterPoint.x) - _panOffset.x;
			_midZoomPoint.y = Math.abs(_currCenterPoint.y) - _panOffset.y;
			_currPointsDistance = _startPointsDistance = _calculatePointsDistance(p, p2);
		}


	},

	// Pointermove/touchmove/mousemove handler
	_onDragMove = function(e) {


		e.preventDefault();

		if(_pointerEventEnabled) {
			var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
			if(pointerIndex > -1) {
				var p = _currPointers[pointerIndex];
				p.x = e.pageX;
				p.y = e.pageY;
				p.clientY = e.clientY;
			}
		}

		if(_isDragging) {
			var touchesList = _getTouchPoints(e);

			if(!_direction && !_moved && !_isZooming) {

				if(_mainScrollPos.x !== _slideSize.x * _currPositionIndex) {
					// if main scroll position is shifted – direction is always horizontal
					_direction = 'h';
				} else {
					var diff = Math.abs(touchesList[0].x - _currPoint.x) - Math.abs(touchesList[0].y - _currPoint.y);
					// check the direction of movement
					if(Math.abs(diff) >= DIRECTION_CHECK_OFFSET) {
						_direction = diff > 0 ? 'h' : 'v';
						_currentPoints = touchesList;
					}

				}

			} else {
				_currentPoints = touchesList;
			}

			_dragDelta = _dragDelta + (_dragPositionY - touchesList[0].clientY);
			_dragPositionY = touchesList[0].clientY;

		}
	},
	//
	_renderMovement =  function() {
		if(!_currentPoints) {
			return;
		}

		var numPoints = _currentPoints.length;

		if(numPoints === 0) {
			return;
		}

		_equalizePoints(p, _currentPoints[0]);

		delta.x = p.x - _currPoint.x;
		delta.y = p.y - _currPoint.y;

		if(_isZooming && numPoints > 1) {

			// Handle behaviour for more than 1 point

			_currPoint.x = p.x;
			_currPoint.y = p.y;

			// check if one of two points changed
			if( !delta.x && !delta.y && _isEqualPoints(_currentPoints[1], p2) ) {
				return;
			}

			_equalizePoints(p2, _currentPoints[1]);


			if(!_zoomStarted) {
				_zoomStarted = true;
				_shout('zoomGestureStarted');

				if ( self.currItem.caption &&  _options.showCaption ){
					self.caption.classList.add('hidden')
				}

			}

			// Distance between two points
			var pointsDistance = _calculatePointsDistance(p,p2);

			var zoomLevel = _calculateZoomLevel(pointsDistance);

			// slightly over the of initial zoom level
			if(zoomLevel > self.currItem.initialZoomLevel + self.currItem.initialZoomLevel / 15) {
				_wasOverInitialZoom = true;
			}

			// Apply the friction if zoom level is out of the bounds
			var zoomFriction = 1,
				minZoomLevel = _getMinZoomLevel(),
				maxZoomLevel = _getMaxZoomLevel();

			if ( zoomLevel < minZoomLevel ) {

				if(_options.pinchToClose && !_wasOverInitialZoom && _startZoomLevel <= self.currItem.initialZoomLevel) {
					// fade out background if zooming out
					var minusDiff = minZoomLevel - zoomLevel;
					var percent = 1 - minusDiff / (minZoomLevel / 1.2);

					_applyBgOpacity(percent);
					_shout('onPinchClose', percent);
					_opacityChanged = true;
				} else {
					zoomFriction = (minZoomLevel - zoomLevel) / minZoomLevel;
					if(zoomFriction > 1) {
						zoomFriction = 1;
					}
					zoomLevel = minZoomLevel - zoomFriction * (minZoomLevel / 3);
				}

			} else if ( zoomLevel > maxZoomLevel ) {
				// 1.5 - extra zoom level above the max. E.g. if max is x6, real max 6 + 1.5 = 7.5
				zoomFriction = (zoomLevel - maxZoomLevel) / ( minZoomLevel * 6 );
				if(zoomFriction > 1) {
					zoomFriction = 1;
				}
				zoomLevel = maxZoomLevel + zoomFriction * minZoomLevel;
			}

			if(zoomFriction < 0) {
				zoomFriction = 0;
			}


			// distance between touch points after friction is applied
			_currPointsDistance = pointsDistance;

			// _centerPoint - The point in the center of two pointers
			_findCenterOfPoints(p, p2, _centerPoint);

			// paning with two pointers pressed
			_currPanDist.x += _centerPoint.x - _currCenterPoint.x;
			_currPanDist.y += _centerPoint.y - _currCenterPoint.y;
			_equalizePoints(_currCenterPoint, _centerPoint);

			_panOffset.x = _calculatePanOffset('x', zoomLevel);
			_panOffset.y = _calculatePanOffset('y', zoomLevel);

			_isZoomingIn = zoomLevel > _currZoomLevel;
			_currZoomLevel = zoomLevel;
			_applyCurrentZoomPan();

		} else {

			// handle behaviour for one point (dragging or panning)

			if(!_direction) {
				return;
			}

			if(_isFirstMove) {
				_isFirstMove = false;

				// subtract drag distance that was used during the detection direction

				if( Math.abs(delta.x) >= DIRECTION_CHECK_OFFSET) {
					delta.x -= _currentPoints[0].x - _startPoint.x;
				}

				if( Math.abs(delta.y) >= DIRECTION_CHECK_OFFSET) {
					delta.y -= _currentPoints[0].y - _startPoint.y;
					_dragDelta -= -(_currentPoints[0].y - _startPoint.y)
				}

			}

			_currPoint.x = p.x;
			_currPoint.y = p.y;
			// do nothing if pointers position hasn't changed
			if(delta.x === 0 && delta.y === 0) {
				return;
			}

			if ( _direction === 'v' && _options.animatedCloseOnScroll && _eventType === 'touchstart' ){
				// _scrollDelta = _scrollDelta+(lastDelta-delta.y);
				_scrollDelta = _dragDelta;
				_dragDelta = 0;

				if ( !_touchScrollDrag && !_isScrollAnimating ){
					_touchScrollDrag = true;

					_stopScrollUpdateLoop();
					_startScrollAnimation();

					var destroyed = false;
					var yMove = 0;
					var inertia = 1;
					var touchDelta = 0;
					_fakeScrollTotal = 0;
					_renderFakeScrollTotal =0;

					var lastTouch = _currPoint.y;
					var yStart = _currPoint.y;

					var touchInertiaFrame;
					var touchScrollFrame;
					var scrollPos = document.documentElement.scrollTop;
					var scrollHeight = document.documentElement.scrollHeight;
					var windowHeight = _viewportSize.y;

					var ticking = false;

					// var transformTargets = $('.content_container, .pinned > div:not(.fixed)');
					// var backdropTargets =$('.backdrop > div');
					// lwarn('Untested C3 quick view and lightbox territory. Methods previously using Jquery now use vanilla JS. See lightbox.js')
					var transformTargets = document.querySelectorAll('.content_container, .pinned > div:not(.fixed)');

					// backdrops are no longer fixed position in C3 - this will be excised
					var backdropTargets = [];
					// var backdropTargets =  document.querySelectorAll('.backdrop > div');

					// backdropTargets.each(function(){
					// 	this.__cacheStyle = this.style;
					// })

					var requestTick = function(){
						if ( ticking){
							return;
						}

						ticking = true;

						touchScrollFrame = requestAnimationFrame(function(){

							transformTargets.style.transform = 'translateY('+-_renderFakeScrollTotal+'px)';
							// transformTargets.css({
							// 	transform:'translateY('+-_renderFakeScrollTotal+'px)'
							// });

							backdropTargets.each(function(i){

								var backdropData = this.parentElement.__backdropData;
								var cachedSize = this.parentElement.__cached_size;
								var pageSize = this.parentElement.__cached_page_size;

								if ( backdropData ){

									var top =0;
									var height = 0;
									var pageHeight = 0;
									if ( cachedSize){
										top = cachedSize.top;
										height = cachedSize.height;
										pageHeight = height;
									}

									if (pageSize){
										pageHeight = pageSize.height;
									}
									var yPos = parseFloat(backdropData.yPos) || 0;


									if ( this.style.position === 'fixed'){
										this.style.position = 'absolute'
									}

									var virtualScrollY = scrollPos + _renderFakeScrollTotal;
									var virtualScrollY2 = scrollPos + _renderFakeScrollTotal + Cargo.Backdrop.cache_window_data.height;

									var backdropContainerY = top+scrollPos;
									var backdropContainerY2 = top+scrollPos+pageHeight									

									if ( backdropContainerY <= virtualScrollY && backdropContainerY2 >= virtualScrollY2){
										var diff = backdropContainerY - virtualScrollY;
										this.style.transform = 'translateY('+(-diff)+'px)'												
									} else if ( backdropContainerY2<virtualScrollY2) {
										this.style.transform = 'translateY('+(pageHeight-Cargo.Backdrop.cache_window_data.height)+'px)'												
									} else {
										this.style.transform = 'translateY(0px)'												
									}

								}
							})

							ticking = false;
						})

					}

					var onTouchMove = function(e){

						if ( e.touches.length == 0 || e.touches.length > 1){
							onTouchEnd();
							cancelScrollOnTouch();
							return;
						}
						e.preventDefault();

						_fakeScrollTotal  = yStart - e.touches[0].pageY;
						_renderFakeScrollTotal = _fakeScrollTotal

						// TODO- handle overflow scrolling a little more elegantly
						if ( _fakeScrollTotal+scrollPos <= 0 ){
							scrollMonitor.__frozen = true;
							_renderFakeScrollTotal = -scrollPos;				
						} else if(_fakeScrollTotal + scrollPos+ windowHeight>=scrollHeight){
							scrollMonitor.__frozen = true;
							_renderFakeScrollTotal = 0;
				
						} else if ( scrollMonitor.__frozen ) {
							delete scrollMonitor.__frozen
						}

						touchDelta = (lastTouch - e.touches[0].pageY);
						lastTouch = e.touches[0].pageY;

						requestTick();						

					}

					var onTouchEnd = function(){

						window.removeEventListener('touchmove',onTouchMove);
						window.removeEventListener('touchend',onTouchEnd);
						window.addEventListener('touchstart',cancelScrollOnTouch);
	
						cancelAnimationFrame(touchScrollFrame);

						transformTargets.style.transform = '';
						// transformTargets.css({
						// 	transform:''
						// });


						backdropTargets.each(function(){
							if ( this.__cacheStyle ){
								this.style = this.__cacheStyle;
								delete this.__cacheStyle;
							}
						})
		
						document.documentElement.scrollTop = document.documentElement.scrollTop + _fakeScrollTotal ;

						inertiaScroll();
						requestAnimationFrame(function(){
							if ( scrollMonitor.__frozen){
								delete scrollMonitor.__frozen
							}
							Cargo.View.Backdrop.updateBackdropScrollPosition(true);
							Cargo.Event.trigger('lightbox-scroll-finished')
						})
					}

					var cancelScrollOnTouch = function(){
						touchDelta = 0;
						cancelAnimationFrame(touchInertiaFrame);
						window.removeEventListener('touchstart',cancelScrollOnTouch);

					}

					var inertiaScroll = function(){

						inertia = inertia * .95;
						var scrollSpeed = touchDelta*inertia;
						document.documentElement.scrollTop = document.documentElement.scrollTop + scrollSpeed;
						if ( Math.abs(scrollSpeed) > .5) {
							touchInertiaFrame = requestAnimationFrame(function(){
								inertiaScroll();
							})
						} else {
							cancelScrollOnTouch();
						}

					}

					window.addEventListener('touchmove',onTouchMove);
					window.addEventListener('touchend',onTouchEnd);
				}

				return;


			} else if (_direction === 'v' && _options.closeOnVerticalDrag) {
				if(!_canPan()) {
					_currPanDist.y += delta.y;
					_panOffset.y += delta.y;

					var opacityRatio = _calculateVerticalDragOpacityRatio();

					_verticalDragInitiated = true;
					_shout('onVerticalDrag', opacityRatio);

					_applyBgOpacity(opacityRatio);
					_applyCurrentZoomPan();
					return ;
				}
			}

			_pushPosPoint(_getCurrentTime(), p.x, p.y);

			if (_direction === 'h' &&  _options.showCaption && !_moved){
				self.caption.classList.add('hidden');
			}

			_moved = true;
			_currPanBounds = self.currItem.bounds;

			var mainScrollChanged = _panOrMoveMainScroll('x', delta);
			if(!mainScrollChanged) {
				_panOrMoveMainScroll('y', delta);

				_roundPoint(_panOffset);
				_applyCurrentZoomPan();
			}

		}

	},

	// Pointerup/pointercancel/touchend/touchcancel/mouseup event handler
	_onDragRelease = function(e) {
		_eventType = '';

		if(_features.isOldAndroid ) {

			if(_oldAndroidTouchEndTimeout && e.type === 'mouseup') {
				return;
			}

			// on Android (v4.1, 4.2, 4.3 & possibly older)
			// ghost mousedown/up event isn't preventable via e.preventDefault,
			// which causes fake mousedown event
			// so we block mousedown/up for 600ms
			if( e.type.indexOf('touch') > -1 ) {
				clearTimeout(_oldAndroidTouchEndTimeout);
				_oldAndroidTouchEndTimeout = setTimeout(function() {
					_oldAndroidTouchEndTimeout = 0;
				}, 600);
			}

		}

		clearTimeout(_dragstartTimer);
		self.template.classList.remove('mouse-down')

		_shout('pointerUp');

		if(_preventDefaultEventBehaviour(e, false)) {
			e.preventDefault();
		}

		var releasePoint;

		if(_pointerEventEnabled) {
			var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');

			if(pointerIndex > -1) {
				releasePoint = _currPointers.splice(pointerIndex, 1)[0];

				if(navigator.pointerEnabled) {
					releasePoint.type = e.pointerType || 'mouse';
				} else {
					var MSPOINTER_TYPES = {
						4: 'mouse', // event.MSPOINTER_TYPE_MOUSE
						2: 'touch', // event.MSPOINTER_TYPE_TOUCH
						3: 'pen' // event.MSPOINTER_TYPE_PEN
					};
					releasePoint.type = MSPOINTER_TYPES[e.pointerType];

					if(!releasePoint.type) {
						releasePoint.type = e.pointerType || 'mouse';
					}
				}

			}
		}

		var touchList = _getTouchPoints(e),
			gestureType,
			numPoints = touchList.length;

		if(e.type === 'mouseup') {
			numPoints = 0;
		}

		// Do nothing if there were 3 touch points or more
		if(numPoints === 2) {
			_currentPoints = null;
			return true;
		}

		// if second pointer released
		if(numPoints === 1) {
			_equalizePoints(_startPoint, touchList[0]);
		}


		// pointer hasn't moved, send "tap release" point
		if(numPoints === 0 && !_direction && !_mainScrollAnimating) {
			if(!releasePoint) {
				if(e.type === 'mouseup') {
					releasePoint = {x: e.pageX+-_viewportPadSize.left+-_viewportPadSize.marginLeft, y: e.pageY+-_viewportPadSize.top+-_viewportPadSize.marginTop, type:'mouse'};
				} else if(e.changedTouches && e.changedTouches[0]) {
					releasePoint = {x: e.changedTouches[0].pageX+-_viewportPadSize.left+-_viewportPadSize.marginLeft, y: e.changedTouches[0].pageY+-_viewportPadSize.top+-_viewportPadSize.marginTop, type:'touch'};
				}
			}

			_shout('touchRelease', e, releasePoint);
		}



		// Difference in time between releasing of two last touch points (zoom gesture)
		var releaseTimeDiff = -1;

		// Gesture completed, no pointers left
		if(numPoints === 0) {
			_isDragging = false;
			framework.unbind(window, _upMoveEvents, self);

			_stopDragUpdateLoop();

			if(_isZooming) {
				// Two points released at the same time
				releaseTimeDiff = 0;
			} else if(_lastReleaseTime !== -1) {
				releaseTimeDiff = _getCurrentTime() - _lastReleaseTime;
			}
		}
		_lastReleaseTime = numPoints === 1 ? _getCurrentTime() : -1;

		if(releaseTimeDiff !== -1 && releaseTimeDiff < 150) {
			gestureType = 'zoom';
		} else {
			gestureType = 'swipe';
		}

		if(_isZooming && numPoints < 2) {
			_isZooming = false;

			// Only second point released
			if(numPoints === 1) {
				gestureType = 'zoomPointerUp';
			}
			_shout('zoomGestureEnded');
		}

		_currentPoints = null;
		if(!_moved && !_zoomStarted && !_mainScrollAnimating && !_verticalDragInitiated && !_touchScrollDrag) {
			// nothing to animate
			return;
		}

		_stopAllAnimations();


		if(!_releaseAnimData) {
			_releaseAnimData = _initDragReleaseAnimationData();
		}

		_releaseAnimData.calculateSwipeSpeed('x');

		if ( _touchScrollDrag ){

			if(_endScrollTimeout) {
				clearTimeout(_endScrollTimeout);
			}
			_touchScrollDrag = false;
			_stopScrollUpdateLoop();
			_resetScrollPosition();

		} else if(_verticalDragInitiated) {

			var opacityRatio = _calculateVerticalDragOpacityRatio();

			if(opacityRatio < _options.verticalDragRange) {
				self.close();
			} else {
				var initalPanY = _panOffset.y,
					initialBgOpacity = _bgOpacity;

				_animateProp('verticalDrag', 0, 1, 300, framework.easing.cubic.out, function(now) {
					_panOffset.y = (self.currItem.initialPosition.y - initalPanY) * now + initalPanY;

					_applyBgOpacity(  (1 - initialBgOpacity) * now + initialBgOpacity );
					_applyCurrentZoomPan();
				});

				_shout('onVerticalDrag', 1);
			}

			return;
		}


		// main scroll
		if(  (_mainScrollShifted || _mainScrollAnimating) && numPoints === 0) {
			var itemChanged = _finishSwipeMainScrollGesture(gestureType, _releaseAnimData);
			if(itemChanged) {
				return;
			}
			gestureType = 'zoomPointerUp';
		}

		// prevent zoom/pan animation when main scroll animation runs
		if(_mainScrollAnimating) {
			return;
		}

		// Complete simple zoom gesture (reset zoom level if it's out of the bounds)
		if(gestureType !== 'swipe') {
			_completeZoomGesture();
			return;
		}

		// Complete pan gesture if main scroll is not shifted, and it's possible to pan current image
		if(!_mainScrollShifted && _currZoomLevel > self.currItem.fitRatio) {
			_completePanGesture(_releaseAnimData);
		}
	},


	// Returns object with data about gesture
	// It's created only once and then reused
	_initDragReleaseAnimationData  = function() {
		// temp local vars
		var lastFlickDuration,
			tempReleasePos;

		// s = this
		var s = {
			lastFlickOffset: {},
			lastFlickDist: {},
			lastFlickSpeed: {},
			slowDownRatio:  {},
			slowDownRatioReverse:  {},
			speedDecelerationRatio:  {},
			speedDecelerationRatioAbs:  {},
			distanceOffset:  {},
			backAnimDestination: {},
			backAnimStarted: {},
			calculateSwipeSpeed: function(axis) {


				if( _posPoints.length > 1) {
					lastFlickDuration = _getCurrentTime() - _gestureCheckSpeedTime + 50;
					tempReleasePos = _posPoints[_posPoints.length-2][axis];
				} else {
					lastFlickDuration = _getCurrentTime() - _gestureStartTime; // total gesture duration
					tempReleasePos = _startPoint[axis];
				}
				s.lastFlickOffset[axis] = _currPoint[axis] - tempReleasePos;
				s.lastFlickDist[axis] = Math.abs(s.lastFlickOffset[axis]);
				if(s.lastFlickDist[axis] > 20) {
					s.lastFlickSpeed[axis] = s.lastFlickOffset[axis] / lastFlickDuration;
				} else {
					s.lastFlickSpeed[axis] = 0;
				}
				if( Math.abs(s.lastFlickSpeed[axis]) < 0.1 ) {
					s.lastFlickSpeed[axis] = 0;
				}

				s.slowDownRatio[axis] = 0.95;
				s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
				s.speedDecelerationRatio[axis] = 1;
			},

			calculateOverBoundsAnimOffset: function(axis, speed) {
				if(!s.backAnimStarted[axis]) {

					if(_panOffset[axis] > _currPanBounds.min[axis]) {
						s.backAnimDestination[axis] = _currPanBounds.min[axis];

					} else if(_panOffset[axis] < _currPanBounds.max[axis]) {
						s.backAnimDestination[axis] = _currPanBounds.max[axis];
					}

					if(s.backAnimDestination[axis] !== undefined) {
						s.slowDownRatio[axis] = 0.7;
						s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
						if(s.speedDecelerationRatioAbs[axis] < 0.05) {

							s.lastFlickSpeed[axis] = 0;
							s.backAnimStarted[axis] = true;

							_animateProp('bounceZoomPan'+axis,_panOffset[axis],
								s.backAnimDestination[axis],
								speed || 300,
								framework.easing.sine.out,
								function(pos) {
									_panOffset[axis] = pos;
									_applyCurrentZoomPan();
								}
							);

						}
					}
				}
			},

			// Reduces the speed by slowDownRatio (per 10ms)
			calculateAnimOffset: function(axis) {
				if(!s.backAnimStarted[axis]) {
					s.speedDecelerationRatio[axis] = s.speedDecelerationRatio[axis] * (s.slowDownRatio[axis] +
												s.slowDownRatioReverse[axis] -
												s.slowDownRatioReverse[axis] * s.timeDiff / 10);

					s.speedDecelerationRatioAbs[axis] = Math.abs(s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis]);
					s.distanceOffset[axis] = s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis] * s.timeDiff;
					_panOffset[axis] += s.distanceOffset[axis];

				}
			},

			panAnimLoop: function() {
				if ( _animations.zoomPan ) {
					_animations.zoomPan.raf = _requestAF(s.panAnimLoop);

					s.now = _getCurrentTime();
					s.timeDiff = s.now - s.lastNow;
					s.lastNow = s.now;

					s.calculateAnimOffset('x');
					s.calculateAnimOffset('y');

					_applyCurrentZoomPan();

					s.calculateOverBoundsAnimOffset('x');
					s.calculateOverBoundsAnimOffset('y');


					if (s.speedDecelerationRatioAbs.x < 0.05 && s.speedDecelerationRatioAbs.y < 0.05) {

						// round pan position
						_panOffset.x = _panOffset.x;
						_panOffset.y = _panOffset.y;
						_applyCurrentZoomPan();

						_stopAnimation('zoomPan');
						return;
					}
				}

			}
		};
		return s;
	},

	_completePanGesture = function(animData) {
		// calculate swipe speed for Y axis (paanning)
		animData.calculateSwipeSpeed('y');

		_currPanBounds = self.currItem.bounds;

		animData.backAnimDestination = {};
		animData.backAnimStarted = {};

		// Avoid acceleration animation if speed is too low
		if(Math.abs(animData.lastFlickSpeed.x) <= 0.05 && Math.abs(animData.lastFlickSpeed.y) <= 0.05 ) {
			animData.speedDecelerationRatioAbs.x = animData.speedDecelerationRatioAbs.y = 0;

			// Run pan drag release animation. E.g. if you drag image and release finger without momentum.
			animData.calculateOverBoundsAnimOffset('x');
			animData.calculateOverBoundsAnimOffset('y');
			return true;
		}

		// Animation loop that controls the acceleration after pan gesture ends
		_registerStartAnimation('zoomPan');
		animData.lastNow = _getCurrentTime();
		animData.panAnimLoop();
	},


	_finishSwipeMainScrollGesture = function(gestureType, _releaseAnimData) {
		var itemChanged;
		if(!_mainScrollAnimating) {
			_currZoomedItemIndex = _currentItemIndex;
		}


		var itemsDiff;

		if(gestureType === 'swipe') {
			var totalShiftDist = _currPoint.x - _startPoint.x,
				isFastLastFlick = _releaseAnimData.lastFlickDist.x < 10;

			// if container is shifted for more than MIN_SWIPE_DISTANCE,
			// and last flick gesture was in right direction
			if(totalShiftDist > MIN_SWIPE_DISTANCE &&
				(isFastLastFlick || _releaseAnimData.lastFlickOffset.x > 20) ) {
				// go to prev item
				itemsDiff = -1;
			} else if(totalShiftDist < -MIN_SWIPE_DISTANCE &&
				(isFastLastFlick || _releaseAnimData.lastFlickOffset.x < -20) ) {
				// go to next item
				itemsDiff = 1;
			}
		}

		var nextCircle;

		if(itemsDiff) {

			_currentItemIndex += itemsDiff;

			if(_currentItemIndex < 0) {
				_currentItemIndex = _options.loop ? _getNumItems()-1 : 0;
				nextCircle = true;
			} else if(_currentItemIndex >= _getNumItems()) {
				_currentItemIndex = _options.loop ? 0 : _getNumItems()-1;
				nextCircle = true;
			}

			if(!nextCircle || _options.loop) {
				_indexDiff += itemsDiff;
				_currPositionIndex -= itemsDiff;
				itemChanged = true;
			}



		}

		var animateToX = _slideSize.x * _currPositionIndex;
		var animateToDist = Math.abs( animateToX - _mainScrollPos.x );
		var finishAnimDuration;


		if(!itemChanged && animateToX > _mainScrollPos.x !== _releaseAnimData.lastFlickSpeed.x > 0) {
			// "return to current" duration, e.g. when dragging from slide 0 to -1
			finishAnimDuration = 333;
		} else {
			finishAnimDuration = Math.abs(_releaseAnimData.lastFlickSpeed.x) > 0 ?
									animateToDist / Math.abs(_releaseAnimData.lastFlickSpeed.x) :
									333;

			finishAnimDuration = Math.min(finishAnimDuration, 400);
			finishAnimDuration = Math.max(finishAnimDuration, 250);
		}

		if(_currZoomedItemIndex === _currentItemIndex) {
			itemChanged = false;
		}

		_mainScrollAnimating = true;

		_shout('mainScrollAnimStart');

		_animateProp('mainScroll', _mainScrollPos.x, animateToX, finishAnimDuration, framework.easing.cubic.out,
			_moveMainScroll,
			function() {
				_stopAllAnimations();
				_mainScrollAnimating = false;
				_currZoomedItemIndex = -1;

				if(itemChanged || _currZoomedItemIndex !== _currentItemIndex) {
					self.updateCurrItem();
				}

				_shout('mainScrollAnimComplete');
			}
		);

		if(itemChanged) {
			self.updateCurrItem(true);
		} else {
			self.updateCaption();
		}

		return itemChanged;
	},

	_calculateZoomLevel = function(touchesDistance) {
		return  1 / _startPointsDistance * touchesDistance * _startZoomLevel;
	},

	// Resets zoom if it's out of bounds
	_completeZoomGesture = function() {

		var destZoomLevel = _currZoomLevel,
			minZoomLevel = _getMinZoomLevel(),
			maxZoomLevel = _getMaxZoomLevel();

		if ( _currZoomLevel < minZoomLevel ) {
			destZoomLevel = minZoomLevel;
		} else if ( _currZoomLevel > maxZoomLevel ) {
			destZoomLevel = maxZoomLevel;
		}

		var destOpacity = 1,
			onUpdate,
			initialOpacity = _bgOpacity;

		if(_opacityChanged && !_isZoomingIn && !_wasOverInitialZoom && _currZoomLevel < minZoomLevel) {
			//_closedByScroll = true;
			self.close();
			return true;
		}

		if(_opacityChanged) {
			onUpdate = function(now) {
				_applyBgOpacity(  (destOpacity - initialOpacity) * now + initialOpacity );
			};
		}

		self.zoomTo(destZoomLevel, 0, 200,  framework.easing.cubic.out, onUpdate);
		return true;
	};


_registerModule('Gestures', {
	publicMethods: {

		initGestures: function() {

			// helper function that builds touch/pointer/mouse events
			var addEventNames = function(pref, down, move, up, cancel) {
				_dragStartEvent = pref + down;
				_dragMoveEvent = pref + move;
				_dragEndEvent = pref + up;
				if(cancel) {
					_dragCancelEvent = pref + cancel;
				} else {
					_dragCancelEvent = '';
				}
			};

			_pointerEventEnabled = _features.pointerEvent;
			if(_pointerEventEnabled && _features.touch) {
				// we don't need touch events, if browser supports pointer events
				_features.touch = false;
			}

			if(_pointerEventEnabled) {
				if(navigator.pointerEnabled) {
					addEventNames('pointer', 'down', 'move', 'up', 'cancel');
				} else {
					// IE10 pointer events are case-sensitive
					addEventNames('MSPointer', 'Down', 'Move', 'Up', 'Cancel');
				}
			} else if(_features.touch) {
				addEventNames('touch', 'start', 'move', 'end', 'cancel');
				_likelyTouchDevice = true;
			} else {
				addEventNames('mouse', 'down', 'move', 'up');
			}

			_upMoveEvents = _dragMoveEvent + ' ' + _dragEndEvent  + ' ' +  _dragCancelEvent;
			_downEvents = _dragStartEvent;

			if(_pointerEventEnabled && !_likelyTouchDevice) {
				_likelyTouchDevice = (navigator.maxTouchPoints > 1) || (navigator.msMaxTouchPoints > 1);
			}
			// make variable public
			self.likelyTouchDevice = _likelyTouchDevice;

			_globalEventHandlers[_dragStartEvent] = _onDragStart;
			_globalEventHandlers[_dragMoveEvent] = _onDragMove;
			_globalEventHandlers[_dragEndEvent] = _onDragRelease; // the Kraken

			if(_dragCancelEvent) {
				_globalEventHandlers[_dragCancelEvent] = _globalEventHandlers[_dragEndEvent];
			}

			// Bind mouse events on device with detected hardware touch support, in case it supports multiple types of input.
			if(_features.touch) {
				_downEvents += ' mousedown';
				_upMoveEvents += ' mousemove mouseup';
				_globalEventHandlers.mousedown = _globalEventHandlers[_dragStartEvent];
				_globalEventHandlers.mousemove = _globalEventHandlers[_dragMoveEvent];
				_globalEventHandlers.mouseup = _globalEventHandlers[_dragEndEvent];
			}

			if(!_likelyTouchDevice) {
				// don't allow pan to next slide from zoomed state on Desktop
				_options.allowPanToNext = false;
			}
		}

	}
});


/*>>gestures*/

/*>>show-hide-transition*/
/**
 * show-hide-transition.js:
 *
 * Manages initial opening or closing transition.
 *
 * If you're not planning to use transition for gallery at all,
 * you may set options hideAnimationDuration and showAnimationDuration to 0,
 * and just delete startAnimation function.
 *
 */

var _showOrHideTimeout,
	_showOrHide = function(item, img, out, completeFn) {

		if(_showOrHideTimeout) {
			clearTimeout(_showOrHideTimeout);
		}

		_initialZoomRunning = true;
		_initialContentSet = true;

		// dimensions of small thumbnail {x:,y:,w:}.
		// Height is optional, as calculated based on large image.
		var thumbBounds;
		if(item.initialLayout) {
			thumbBounds = item.initialLayout;
			item.initialLayout = null;
		} else {
			thumbBounds = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
		}			

		var duration = out ? _options.hideAnimationDuration : _options.showAnimationDuration;
		var onComplete = function() {
			_stopAnimation('initialZoom');
			if(!out) {
				_applyBgOpacity(1);
				if(img) {
					img.style.display = 'block';
				}


				if( item.autoplay){
					const mediaItem = item.container.querySelector('media-item');
					if( mediaItem){
						mediaItem.onload = ()=>{
							mediaItem.play?.();
						};
						
					}

				}				

				framework.addClass(template, 'quick-view-hide-overflow')
				framework.addClass(template, 'quick-view-animated-in');
				_shout('initialZoom' + (out ? 'OutEnd' : 'InEnd'));
			} else {
				self.template.removeAttribute('style');
				self.bg.removeAttribute('style');
			}

			if(completeFn) {
				completeFn();
			}
			_initialZoomRunning = false;
		};

		// if bounds aren't provided, just open gallery without animation
		if(!duration || !thumbBounds || thumbBounds.x === undefined) {
			_shout('initialZoom' + (out ? 'Out' : 'In') );
			_currZoomLevel = item.initialZoomLevel;
			_equalizePoints(_panOffset,  item.initialPosition );
			_applyCurrentZoomPan();
			template.style.opacity = out ? 0 : 1;
			_applyBgOpacity(1);

			if(duration) {
				setTimeout(function() {
					onComplete();
				}, duration);
			} else {
				onComplete();
			}

			return;
		}

		var startAnimation = function() {

			var closeWithRaf = _closedByScroll,
			// var closeWithRaf = true,
				fadeEverything = self.currItem.loadError || _options.showHideOpacity,
				fadeEverythingAtEnd = _touchScrollDrag;

			var animDelay = out ? 25 : 90;
			if ( closeWithRaf ){
				animDelay =0;
			}

			// apply hw-acceleration to image
			if(item.miniImg) {
				item.miniImg.style.webkitBackfaceVisibility = 'hidden';
			}
			var itemW = parseFloat(item.w);
			var itemH = parseFloat(item.h);

			if ( item.useViewportWidth ){
				itemW = (_viewportSize.x-(_viewportPadSize.left+_viewportPadSize.right))* item.viewportWidthPercentage
			}

			if ( item.useViewportHeight){
				itemH = (_viewportSize.y-(_viewportPadSize.top+_viewportPadSize.bottom))* item.viewportHeightPercentage
			}

			var thumbRatio = thumbBounds.w/thumbBounds.h;
			var itemRatio = itemW/itemH;
			var useHeightRatio = thumbRatio > itemRatio;

			if(!out) {

				_currZoomLevel = useHeightRatio ? (thumbBounds.h / itemH) : (thumbBounds.w / itemW);


				var xOff = (thumbBounds.w - itemW*_currZoomLevel)*.5;
				var yOff = (thumbBounds.h - itemH*_currZoomLevel)*.5;


				var rotatedXOff = xOff*Math.cos(thumbBounds.transform.rotation) - yOff*Math.sin(thumbBounds.transform.rotation);
				var rotatedYOff = xOff*Math.sin(thumbBounds.transform.rotation) + yOff*Math.cos(thumbBounds.transform.rotation);

				_panOffset.rotation = thumbBounds.transform.rotation;
				_panOffset.y = thumbBounds.y+-(_viewportPadSize.top+_viewportPadSize.marginTop)+rotatedYOff;
				_panOffset.x = thumbBounds.x+-(_viewportPadSize.left+_viewportPadSize.marginLeft)+rotatedXOff;
			
				self[fadeEverything ? 'template' : 'bg'].style.opacity = 0.001;
				_applyCurrentZoomPan();
				_panOffset.rotation = 0;
				
			}

			_registerStartAnimation('initialZoom');

			if(out && !closeWithRaf) {
				framework.removeClass(template, 'quick-view-animated-in');
			}

			if (out){

				framework.removeClass(template, 'quick-view-hide-overflow')

				var index = self.getCurrentIndex();

				// force inactive holders to go away
				_.each(self.itemHolders, function(holder){
					if (holder.index !== index){
						holder.el.style.display = 'none'
					}
				})

				if (  _options.showCaption ){
					self.caption.classList.add('hidden')					
				}

			}

			const fadeThumbnail = self.currItem.el?.getAttribute?.('rel') === 'quick-view';

			if(fadeEverything || fadeEverythingAtEnd || fadeThumbnail) {
				if(out) {
					framework[ (closeWithRaf ? 'remove' : 'add') + 'Class' ](template, 'quick-view-animate_opacity');
				} else {
					setTimeout(function() {
						framework.addClass(template, 'quick-view-animate_opacity');
					}, 30);
				}
			}

			var animationSetup = function(){
				_shout('initialZoom' + (out ? 'Out' : 'In') );
				if(!out) {

					// "in" animation always uses CSS transitions (instead of rAF).
					// CSS transition work faster here,
					// as developer may also want to animate other things,
					// like ui on top of sliding area, which can be animated just via CSS

					_currZoomLevel = item.initialZoomLevel;

					_equalizePoints(_panOffset,  item.initialPosition );
					_applyCurrentZoomPan();
					_applyBgOpacity(1);

					if( _currZoomElementStyle ){
						_currZoomElementStyle.opacity = '';
						_currZoomElementStyle.transitionDuration = '';
						const checkHeight = item.container.offsetHeight
					}
					

					if(fadeEverything) {
						template.style.opacity = 1;
					} else {
						_applyBgOpacity(1);
					}

					_showOrHideTimeout = setTimeout(onComplete, duration + 20);
				} else {

			
					// "out" animation uses rAF only when PhotoSwipe is closed by browser scroll, to recalculate position
					var destZoomLevel = useHeightRatio ? (thumbBounds.h / itemH) : (thumbBounds.w / itemW);
					var xOff = (thumbBounds.w - itemW*destZoomLevel)*.5;
					var yOff = (thumbBounds.h - itemH*destZoomLevel)*.5;					
					var rotatedXOff = xOff*Math.cos(thumbBounds.transform.rotation) - yOff*Math.sin(thumbBounds.transform.rotation);
					var rotatedYOff = xOff*Math.sin(thumbBounds.transform.rotation) + yOff*Math.cos(thumbBounds.transform.rotation);

					var initialPanOffset = {
							x: _panOffset.x,
							y: _panOffset.y,
							rotation: 0
						},
						initialZoomLevel = _currZoomLevel,
						initalBgOpacity = _bgOpacity,
						initialScroll = document.documentElement.scrollTop,
						intialRenderScroll = _renderFakeScrollTotal,
						onUpdate = function(now) {


							var diff = (initialScroll-document.documentElement.scrollTop);
							var fakeDiff = (intialRenderScroll - _renderFakeScrollTotal);

							if(now === 1) {
								_currZoomLevel = destZoomLevel;
								_panOffset.x = thumbBounds.x+-(_viewportPadSize.left+_viewportPadSize.marginLeft)+rotatedXOff;
								_panOffset.y = thumbBounds.y+diff+fakeDiff+-(_viewportPadSize.top+_viewportPadSize.marginTop)+rotatedYOff;
								_panOffset.rotation = thumbBounds.transform.rotation;
							} else {
								_currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel;
								_panOffset.x = (thumbBounds.x + -initialPanOffset.x+-(_viewportPadSize.left+_viewportPadSize.marginLeft)+rotatedXOff) * now + initialPanOffset.x;
								_panOffset.y = (thumbBounds.y+diff+fakeDiff+-(_viewportPadSize.top+_viewportPadSize.marginTop)+rotatedYOff) * now + (1-now)* (initialPanOffset.y+diff+fakeDiff);
								_panOffset.rotation = (thumbBounds.transform.rotation - initialPanOffset.rotation) * now + initialPanOffset.rotation;
							}

							_applyCurrentZoomPan();
							// fade when dragging out because async scroll means final matchup is messy
							if (fadeEverythingAtEnd){
								var fader = 1-now;
								if ( Math.hasOwnProperty('cbrt')){
									var x = 1-Math.cbrt(fader);
									fader = 1-(x*x*x*x)
								}
								template.style.opacity = fader;
							} else if(fadeEverything) {
								template.style.opacity = 1 - now;
							} else {
								_applyBgOpacity( initalBgOpacity - now * initalBgOpacity );
							}
						};

					if(closeWithRaf) {
						_animateProp('initialZoom', 0, 1, duration, framework.easing.cubic.out, onUpdate, onComplete);
					} else {
						onUpdate(1);
						_showOrHideTimeout = setTimeout(onComplete, duration + 20);
					}
				}
			}

			if ( animDelay === 0){
				animationSetup();
			} else {
				_showOrHideTimeout = setTimeout(function() {
					animationSetup();
				}, animDelay);
			}	

			 // Main purpose of this delay is to give browser time to paint and
			// create composite layers of PhotoSwipe UI parts (background, controls, caption, arrows).
			// Which avoids lag at the beginning of scale transition.
		};


		startAnimation();

	};

/*>>show-hide-transition*/

/*>>items-controller*/
/**
*
* Controller manages gallery items, their dimensions, and their content.
*
*/

var _items,
	_tempPanAreaSize = {},
	_imagesToAppendPool = [],
	_initialContentSet,
	_initialZoomRunning,
	_controllerDefaultOptions = {
		index: 0,
		errorMsg: '<div class="quick-view-error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
		forceProgressiveLoading: false, // TODO
		preload: [1,1],
		getNumItemsFn: function() {
			return _items.length;
		}
	};


var _getItemAt,
	_getNumItems,
	_initialIsLoop,
	_getZeroBounds = function() {
		return {
			center:{x:0,y:0},
			max:{x:0,y:0},
			min:{x:0,y:0}
		};
	},
	_calculateSingleItemPanBounds = function(item, realPanElementW, realPanElementH ) {

		var bounds = item.bounds;

		//alignHorizontal
		if ( _options.alignHorizontal === 'left' ){
			// position of element when it's centered
			bounds.center.x = 0;
		} else if ( _options.alignHorizontal === 'right' ){
			// position of element when it's centered
			bounds.center.x = (_tempPanAreaSize.x - realPanElementW) + item.hGap.left;
		} else {
			// position of element when it's centered
			bounds.center.x = ((_tempPanAreaSize.x - realPanElementW)/ 2) + item.hGap.left;
		}


		if ( _options.alignVertical === 'top' ){
			bounds.center.y = 0;
		} else if ( _options.alignVertical === 'bottom' ){
			bounds.center.y = (_tempPanAreaSize.y - realPanElementH) + item.vGap.top;	
		} else {
			bounds.center.y = ((_tempPanAreaSize.y - realPanElementH) / 2) + item.vGap.top;	
		}

		// maximum pan position
		bounds.max.x = (realPanElementW > _tempPanAreaSize.x) ?
							_tempPanAreaSize.x - realPanElementW + item.hGap.left :
							bounds.center.x;

		bounds.max.y = (realPanElementH > _tempPanAreaSize.y) ?
							_tempPanAreaSize.y - realPanElementH + item.vGap.top :
							bounds.center.y;

		// minimum pan position
		bounds.min.x = (realPanElementW > _tempPanAreaSize.x) ? item.hGap.left : bounds.center.x;
		bounds.min.y = (realPanElementH > _tempPanAreaSize.y) ? item.vGap.top : bounds.center.y;
	},
	_calculateItemSize = function(item, viewportSize, zoomLevel) {



			var isInitial = !zoomLevel;

			if(isInitial) {
				if(!item.vGap) {
					item.vGap = {top:0,bottom:0};
				}

				if(!item.hGap) {
					item.hGap = {left:0,right:0};
				}
				// allows overriding vertical margin for individual items
				_shout('parseVerticalMargin', item);
			}

			if ( item.useViewportHeight || item.useViewportWidth){
				_tempPanAreaSize.x = viewportSize.x - item.hGap.left - item.hGap.right;
				_tempPanAreaSize.y = viewportSize.y - item.vGap.top - item.vGap.bottom;
			} else {
				_tempPanAreaSize.x = viewportSize.x - item.hGap.left - item.hGap.right + -(_viewportPadSize.left+_viewportPadSize.right);
				_tempPanAreaSize.y = viewportSize.y - item.vGap.top - item.vGap.bottom + -(_viewportPadSize.top+_viewportPadSize.bottom);
			}




			if (isInitial) {

				var w = item.w;
				var h = item.h;

				if ( item.useViewportWidth){
					w = (viewportSize.x-(_viewportPadSize.left+_viewportPadSize.right) )* item.viewportWidthPercentage
				}

				if (item.useViewportHeight){
					h = (viewportSize.y-(_viewportPadSize.top+_viewportPadSize.bottom))* item.viewportHeightPercentage
				}


				var hRatio = _tempPanAreaSize.x / w;
				var vRatio = _tempPanAreaSize.y / h;

				if ( item.useViewportHeight || item.useViewportWidth){
					item.fitRatio = 1;
					// item.fitRatio = 1;
				} else {
					item.fitRatio = hRatio < vRatio ? hRatio : vRatio;
				}

				//item.fillRatio = hRatio > vRatio ? hRatio : vRatio;

				var scaleMode = _options.scaleMode;

				if (scaleMode === 'orig') {
					zoomLevel = 1;
				} else if (scaleMode === 'fit') {
					zoomLevel = item.fitRatio;
				}

				if (zoomLevel > 1) {
					zoomLevel = 1;
				}
				
				if ( zoomLevel == 0){
					zoomLevel = 0.01;
				}					

				item.initialZoomLevel = zoomLevel;

				if(!item.bounds) {
					// reuse bounds object
					item.bounds = _getZeroBounds();
				}
			}



			if(!zoomLevel) {

				return;

			}

			var w = item.w;
			var h = item.h;

			if ( item.useViewportWidth){
				w = viewportSize.x* item.viewportWidthPercentage
			}

			if (item.useViewportHeight){
				h = viewportSize.y* item.viewportHeightPercentage
			}

			if ( item.useViewportHeight || item.useViewportWidth){
				zoomLevel = 1;
			}

			_calculateSingleItemPanBounds(item, w * zoomLevel, h * zoomLevel);
			if (isInitial && zoomLevel === item.initialZoomLevel) {
				item.initialPosition = item.bounds.center;
			}

			return item.bounds;
	

	},




	_appendImage = function(index, item, baseDiv, img, preventAnimation, clearPlaceholder) {

		if(item.loadError) {
			return;
		}

		if(img) {

			item.imageAppended = true;
			_setImageSize(item, img, (item === self.currItem && _renderMaxResolution) );

			// in old behavior the placeholder was kept around but hidden	
// 
// 			img.classList.add('quick-view-item')
// 			baseDiv.appendChild(img);

			// if(clearPlaceholder) {
			// 	console.log('placeholder');
			// 	if ( item.placeholder) {
			// 		item.placeholder.classList.remove('quick-view-item');
			// 	}
			// 	setTimeout(function() {
			// 		if(item && item.loaded && item.placeholder) {
			// 			item.placeholder.style.display = 'none';
			// 			item.placeholder = null;
			// 		}
			// 	}, 500);
			// }


			// new behavior the placeholder is 'upgraded' to become the item itself

			if(clearPlaceholder ) {
				if ( item.placeholder) {
					item.placeholder.classList.remove('quick-view-item');
				}
				setTimeout(function() {
					if(item && item.loaded && item.placeholder) {
						item.placeholder.style.display = 'none';
						item.placeholder = null;
					}
				}, 500);
			} else {
				img.classList.add('quick-view-item')
				baseDiv.appendChild(img);				
			}
		}

		const mediaItem = item.container.querySelector('media-item');


		if( mediaItem){

			dispatch(mediaItem, 'lazyLoadIntersectionChange', {
				visible: true,
				position: 'inside',
			}, {
				bubbles: false
			});

			dispatch(mediaItem, 'viewportIntersectionChange', {
				visible: true,
				position: 'inside',
			}, {
				bubbles: false
			});	

			if( item.hash && item.hash !== 'placeholder' && mediaItem.hasAttribute('src') ){
				mediaItem.setAttribute('hash', item.hash);
				mediaItem.removeAttribute('src');

			// if we loaded a poster in place
			} else if(item.src && mediaItem.getAttribute('src') !== item.src){
				if( item.posterSrc && !mediaItem.poster){
					mediaItem.setAttribute('poster', item.posterSrc);
				}
				mediaItem.setAttribute('src', item.src);
			} else if ( item.model){
				mediaItem.model = item.model;
			}

			// doing this because safari doesn't render its video shadow root correctly so
			// we need to jiggle the handle
			const interiorVideoItem = mediaItem.shadowRoot.querySelector('video');
			if( interiorVideoItem){
				interiorVideoItem.style.display = 'table';
				setTimeout(()=>{
					interiorVideoItem.style.display = ''
				}, 0);
				
			}

			if( item.autoplay ){
				mediaItem.onload = ()=>{
					setTimeout(()=>{
						// mediaItem.setCurrentTime?.(0);
						mediaItem?.play?.();
					});
				};					
			}
		

		}

	},


	_preloadImage = function(item) {

		item.loading = true;
		item.loaded = false;

		// don't make preloader into main image
		// because we now use media-items for this
		// var img = item.img = framework.createEl('quick-view-img', 'img');

		var img = document.createElement('img');

		var onComplete = function() {
			item.loading = false;
			item.loaded = true;

			if(item.loadComplete) {
				item.loadComplete(item);
			} else {
				item.img = null; // no need to store image object
			}
			img.onload = img.onerror = null;
			img = null;
		};
		img.onload = onComplete;
		img.onerror = function() {
			item.loadError = true;
			onComplete();
		};


		var imgSrc = item.el?.shadowRoot?.querySelector('img[part*="media"]')?.src ?? item.posterSrc ?? null;

		// if there's a src set on the item and it doesn't match the current one
		// use the item.src because it's a quick view link rather than a zoomed version of itself
		if(imgSrc && item.src && imgSrc !== item.src ){ 

			if(
				item.src.toLowerCase().endsWith('.jpg') ||
				item.src.toLowerCase().endsWith('.gif') ||
				item.src.toLowerCase().endsWith('.png') || 
				item.src.toLowerCase().endsWith('.webp') ||
				item.src.toLowerCase().endsWith('.jpeg') || 
				item.src.toLowerCase().endsWith('.svg') 
			) {
				imgSrc = item.src;	

			// loading a domain - skip loading
			} else {
				imgSrc = null;
			}
			
		}

		if (imgSrc ){
			img.setAttribute('decoding', 'sync');
			img.setAttribute('src', imgSrc );

		} else {
			// no src found, go to complete
			setTimeout(()=>{
				onComplete();
			});
		}
	},


	_checkForError = function(item, cleanUp) {
		if(item.src && item.loadError && item.container) {

			if(cleanUp) {
				item.container.innerHTML = '';
			}

			item.container.innerHTML = _options.errorMsg.replace('%url%',  item.src );
			return true;

		}
	},
	_setImageSize = function(item, img, maxRes) {

		if(!img) {
			img = item.container.lastChild;
		}

		var w = maxRes ? item.w : item.w * item.fitRatio;
		var h = maxRes ? item.h : item.h * item.fitRatio;

		var unzoomedW = item.w * item.fitRatio;
		var unzoomedH = item.h * item.fitRatio;

		if ( item.useViewportWidth){
			w = _viewportSize.x* item.viewportWidthPercentage;
			w = unzoomedW = w - (_viewportPadSize.left+_viewportPadSize.right);
		}

		if (item.useViewportHeight){
			h = _viewportSize.y* item.viewportHeightPercentage
			h = unzoomedH = h - (_viewportPadSize.top+_viewportPadSize.bottom);
		}
		
		item.renderedSize = {
			w: unzoomedW,
			h: unzoomedH,
		}

		if ( item === self.currItem ){
			_setCaptionSize(item)
		}

		// clamp to pixels if the pad size is large enough to make it not noticeable	
		if(	
			!_isDragging &&	
			_viewportPadSize.top > 5 &&	
			_viewportPadSize.right > 5 &&	
			_viewportPadSize.bottom > 5 &&	
			_viewportPadSize.left > 5 	
		) {	
			w = Math.round(w);	
			h = Math.round(h);	
		}

		img.style.transform = 'translate3d(0,0,0)';
		img.style.width = w + 'px';
		img.style.height = h + 'px';
		img.style.setProperty('--frame-padding',  h+'px');
		img.style.setProperty('padding',  '0px');
		img.style.setProperty('border',  'none');
		img.style.setProperty('outline',  'none');

	},

	_setCaptionSize = function(item) {
		var w= item.renderedSize.w;
		var h = item.renderedSize.h;

		var zoom = Math.max(1, item.fitRatio)

		self.captionWrapper.style.width = (w/zoom)+'px';

		self.captionWrapper.style.right = _viewportPadSize.right +'px';
		self.captionWrapper.style.left = _viewportPadSize.left +'px';

		var verticalSpace = 0;
		switch(_options.alignVertical){
			case "center":
				verticalSpace = (_viewportSize.y + -_viewportPadSize.bottom + -_viewportPadSize.top + (-h/zoom) )*.5 + _viewportPadSize.bottom;
				break;
			case "top":
				verticalSpace = (_viewportSize.y + -_viewportPadSize.bottom + -_viewportPadSize.top + (-h/zoom) ) + _viewportPadSize.bottom;
				break;
			case "bottom":
				verticalSpace = _viewportPadSize.bottom;
				break;
		}

		self.captionWrapper.style.height = verticalSpace +'px';
	},

	_appendImagesPool = function() {

		if(_imagesToAppendPool.length) {
			var poolItem;

			for(var i = 0; i < _imagesToAppendPool.length; i++) {
				poolItem = _imagesToAppendPool[i];
				if( poolItem.holder.index === poolItem.index ) {
					_appendImage(poolItem.index, poolItem.item, poolItem.baseDiv, poolItem.img, false, poolItem.clearPlaceholder);
				}
			}
			_imagesToAppendPool = [];
		}
	};



_registerModule('Controller', {

	publicMethods: {

		lazyLoadItem: function(index) {
			index = _getLoopedId(index);
			var item = _getItemAt(index);

			if(!item || ((item.loaded || item.loading) && !_itemsNeedUpdate)) {
				return;
			}

			_shout('gettingData', index, item);

			_preloadImage(item);
		},
		initController: function() {
			framework.extend(_options, _controllerDefaultOptions, true);
			self.items = _items = items;
			_getItemAt = self.getItemAt;
			_getNumItems = _options.getNumItemsFn; //self.getNumItems;


			_initialIsLoop = _options.loop;
			if(_getNumItems() < 3) {
				_options.loop = false; // disable loop if less then 3 items
			}

			_listen('beforeChange', function(diff) {

				var p = _options.preload,
					isNext = diff === null ? true : (diff >= 0),
					preloadBefore = Math.min(p[0], _getNumItems() ),
					preloadAfter = Math.min(p[1], _getNumItems() ),
					i;


				for(i = 1; i <= (isNext ? preloadAfter : preloadBefore); i++) {
					self.lazyLoadItem(_currentItemIndex+i);
				}
				for(i = 1; i <= (isNext ? preloadBefore : preloadAfter); i++) {
					self.lazyLoadItem(_currentItemIndex-i);
				}
			});

			_listen('initialLayout', function() {
				self.currItem.initialLayout = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
			});

			_listen('mainScrollAnimComplete', _appendImagesPool);
			_listen('initialZoomInEnd', _appendImagesPool);



			_listen('destroy', function() {
				var item;
				for(var i = 0; i < _items.length; i++) {
					item = _items[i];
					// remove reference to DOM elements, for GC
					if(item.container) {
						item.container = null;
					}
					if(item.placeholder) {
						item.placeholder = null;
					}
					if(item.img) {
						item.img = null;
					}
					if(item.preloader) {
						item.preloader = null;
					}
					if(item.loadError) {
						item.loaded = item.loadError = false;
					}
				}
				_imagesToAppendPool = null;
			});
		},


		getItemAt: function(index) {
			if (index >= 0) {
				return _items[index] !== undefined ? _items[index] : false;
			}
			return false;
		},

		allowProgressiveImg: function() {
			// 1. Progressive image loading isn't working on webkit/blink
			//    when hw-acceleration (e.g. translateZ) is applied to IMG element.
			//    That's why in PhotoSwipe parent element gets zoom transform, not image itself.
			//
			// 2. Progressive image loading sometimes blinks in webkit/blink when applying animation to parent element.
			//    That's why it's disabled on touch devices (mainly because of swipe transition)
			//
			// 3. Progressive image loading sometimes doesn't work in IE (up to 11).

			// Don't allow progressive loading on non-large touch devices

			// addendum: it's no longer 2015, the answer is yes
			return true;
			// return _options.forceProgressiveLoading || !_likelyTouchDevice || _options.mouseUsed || screen.width > 1200;
			// 1200 - to eliminate touch devices with large screen (like Chromebook Pixel)
		},

		setContent: function(holder, index) {


			if(_options.loop) {
				index = _getLoopedId(index);
			}

			var prevItem = self.getItemAt(holder.index);
			if(prevItem) {
				prevItem.container = null;
			}

			var item = self.getItemAt(index),
				img;

			if(!item) {
				holder.el.innerHTML = '';
				return;
			}

			// allow to override data
			_shout('gettingData', index, item);

			holder.index = index;
			holder.item = item;

			// base container DIV is created only once for each of 3 holders
			var baseDiv = item.container = framework.createEl('quick-view-zoom-wrap');
			var mediaItem = holder.el?.querySelector('media-item');

			var iframeInside = false;
			if( mediaItem ){
				const fileType = mediaItem.getFileType();
				if( fileType.startsWith('vimeo') || fileType.startsWith('youtube') || fileType ==='url'){
					iframeInside = true;
				}

			}

			if ( iframeInside){
				holder.el.classList.add('iframe-item')
			} else {
				holder.el.classList.remove('iframe-item')
			}

			_checkForError(item);

			_calculateItemSize(item, _viewportSize);

			// no error, but item is not yet loaded
			if(!item.loadError && !item.loaded) {

				item.loadComplete = function(item) {
					// gallery closed before image finished loading
					if(!_isOpen) {
						return;
					}

					// check if holder hasn't changed while image was loading
					if(holder && holder.index === index ) {
						if( _checkForError(item, true) ) {
							item.loadComplete = item.img = null;
							_calculateItemSize(item, _viewportSize);
							_applyZoomPanToItem(item);

							if(holder.index === _currentItemIndex) {
								// recalculate dimensions
								self.updateCurrZoomItem();
							}

							return;
						}
						if( !item.imageAppended ) {
							if(_features.transform && (_mainScrollAnimating || _initialZoomRunning) ) {
								_imagesToAppendPool.push({
									item:item,
									baseDiv:baseDiv,
									img:item.img,
									index:index,
									holder:holder,
									clearPlaceholder: true
								});
							} else {
								_appendImage(index, item, baseDiv, item.img, _mainScrollAnimating || _initialZoomRunning, true);
							}
						} else {

							// remove preloader & mini-img
							// if(!_initialZoomRunning && item.placeholder) {
							// 		item.placeholder.style.display = 'none';
							// 		item.placeholder = null;
							// 	}
						}
					}

					item.loadComplete = null;
					item.img = null; // no need to store image element after it's added
					_shout('imageLoadComplete', index, item);
				};

				var placeholderClassName = 'quick-view-item';

				var placeholder = framework.createEl(placeholderClassName, 'media-item');

				placeholder.setAttribute('disable-scroll-animation', true)					
				placeholder.setAttribute('disable-zoom', true);
				placeholder.setAttribute('width', item.w);
				placeholder.setAttribute('height', item.h);	
				placeholder.setAttribute('uses', 'inline-part-styles');
				placeholder.setAttribute('media-style', 'padding: 0px; border-width: 0px; border-radius: 0px; outline-width: 0px; background: transparent;');
				placeholder.setAttribute('style', 'padding: 0, border-width: 0px; border-radius: 0px; outline-width: 0px; background: transparent;');

				if( item.usePlaceholder){

					placeholder.setAttribute('hash', 'placeholder');

				} else if( item.fileType == 'video' || item.fileType.startsWith('vimeo') || item.fileType.startsWith('youtube') ){

					if ( item.src ){
						if( item.posterSrc){
							placeholder.setAttribute('src', item.posterSrc);
						} else {
							placeholder.setAttribute('src', item.src);							
						}

						
					} else if( item.hash && item.hash !== 'placeholder') {
						placeholder.setAttribute('hash', item.hash);
					}			

					if( item.autoplay){
						
						item.el?.getCurrentTime?.().then(time=>{
							placeholder.onload = ()=>{
								setTimeout(()=>{
									placeholder.setCurrentTime?.(time);
								}, 0)
							};
						});
						placeholder.setAttribute('muted', true);
						placeholder.setAttribute('loop', true);
						placeholder.setAttribute('autoplay', true);
						placeholder.setAttribute('browser-default', false);

					} else {
						// pause the media-item that's in the regular page
						item.el?.pause?.();

						if( item.poster){
							placeholder.setAttribute('poster', item.poster);
						}
						placeholder.setAttribute('browser-default', true);
					}


				} else if (item.fileType === 'image') {

					var imgSrc = item.el?.shadowRoot?.querySelector('img[part*="media"]')?.src

					// if there's a src set on the item and it doesn't match the current one
					// use the item.src because it's a quick view link rather than a zoomed version of itself
					if(imgSrc && item.src && imgSrc !== item.src ){ 
						imgSrc = item.src;
					}					

					// if we have a preloading src, put that hash in place
					if( imgSrc ){
						placeholder.setAttribute('src', imgSrc);
					} else if (item.src){
						placeholder.setAttribute('src', item.src);
					} else if(item.hash && item.hash !== 'placeholder') {
						placeholder.setAttribute('hash', item.hash);
					}						
				} else if ( item.fileType === 'url'){
					if ( item.src ){
						placeholder.setAttribute('src', item.src)	
					} else if( item.hash && item.hash !== 'placeholder') {
						placeholder.setAttribute('hash', item.hash);
					}						
				}
					

				// placeholder.removeAttribute('style');
				_setImageSize(item, placeholder);
				baseDiv.appendChild(placeholder);

				dispatch(placeholder, 'lazyLoadIntersectionChange', {
					visible: true,
					position: 'inside',
				}, {
					bubbles: false
				});

				dispatch(placeholder, 'viewportIntersectionChange', {
					visible: true,
					position: 'inside',
				}, {
					bubbles: false
				});

				item.placeholder = placeholder;

				if(!item.loading) {
					_preloadImage(item);
				}


				if( self.allowProgressiveImg() ) {
					// just append image
					if(!_initialContentSet && _features.transform) {
						_imagesToAppendPool.push({
							item:item,
							baseDiv:baseDiv,
							img:item.img,
							index:index,
							holder:holder
						});
					} else {
						_appendImage(index, item, baseDiv, item.img, true, true);
					}
				}

			} else if( !item.loadError) {
				// image object is created every time, due to bugs of image loading & delay when switching images
				img = framework.createEl('quick-view-item', 'media-item');


				img.setAttribute('disable-scroll-animation', true);				
				img.setAttribute('disable-zoom', true)
				img.setAttribute('width', item.w);
				img.setAttribute('height', item.h);
				img.setAttribute('disable-scroll-animation', true)					
				img.setAttribute('disable-zoom', true);
				img.setAttribute('width', item.w);
				img.setAttribute('height', item.h);	
				img.setAttribute('uses', 'inline-part-styles');
				img.setAttribute('media-style', 'padding: 0px; border-width: 0px; border-radius: 0px; outline-width: 0px;');
				img.setAttribute('style', 'padding: 0, border-width: 0px; border-radius: 0px; outline-width: 0px;');



				if( item.usePlaceholder){
					img.setAttribute('hash', 'placeholder');
				} else if(item.hash) {
					img.setAttribute('hash', item.hash);
				} else if ( item.src ){
					img.setAttribute('src', item.src);
				}


				if( item.fileType == 'video' || item.fileType.startsWith('vimeo') || item.fileType.startsWith('youtube') ){


					if( item.autoplay){
						img.setAttribute('muted', true);
						img.setAttribute('loop', true);
						img.setAttribute('browser-default', false);
					} else {
						img.setAttribute('browser-default', true);
					}							

				}


				_setImageSize(item, img);

				// append into container without keeping lightbox placeholder
				_appendImage(index, item, baseDiv, img, true);
			} else if ( item.fileType == 'url' ){
				_setImageSize(item, null);				
			}



			if(!_initialContentSet && index === _currentItemIndex) {
				_currZoomElementStyle = baseDiv.style;
				_showOrHide(item, (img ||item.img) );
			} else {
				_applyZoomPanToItem(item);	
			}


			holder.el.innerHTML = '';
			holder.el.appendChild(baseDiv);

			var mediaItem = holder.el.querySelector('media-item');
			if( mediaItem){
				dispatch(mediaItem, 'lazyLoadIntersectionChange', {
					visible: true,
					position: 'inside',
				}, {
					bubbles: false
				});

				dispatch(mediaItem, 'viewportIntersectionChange', {
					visible: true,
					position: 'inside',
				}, {
					bubbles: false
				});				
			}			

		},

		cleanSlide: function( item ) {
			if(item.img ) {

				item.img.onload = item.img.onerror = null;
			}
			item.loaded = item.loading = item.img = item.imageAppended = false;
		}

	}
});

/*>>items-controller*/

/*>>tap*/
/**
 * tap.js:
 *
 * Displatches tap and double-tap events.
 *
 */

var tapTimer,
	tapReleasePoint = {},
	_dispatchTapEvent = function(origEvent, releasePoint, pointerType) {
		var e = document.createEvent( 'CustomEvent' ),
			eDetail = {
				origEvent:origEvent,
				target:origEvent.target,
				releasePoint: releasePoint,
				pointerType:pointerType || 'touch'
			};

		e.initCustomEvent( 'pswpTap', true, true, eDetail );
		origEvent.target.dispatchEvent(e);
	};

_registerModule('Tap', {
	publicMethods: {
		initTap: function() {
			_listen('firstTouchStart', self.onTapStart);
			_listen('touchRelease', self.onTapRelease);
			_listen('destroy', function() {
				tapReleasePoint = {};
				tapTimer = null;
			});
		},
		onTapStart: function(touchList) {
			if(touchList.length > 1) {
				clearTimeout(tapTimer);
				tapTimer = null;
			}
		},
		onTapRelease: function(e, releasePoint) {
			if(!releasePoint) {
				return;
			}

			if(!_moved && !_isMultitouch && !_numAnimations) {
				var p0 = releasePoint;
				if(tapTimer) {
					clearTimeout(tapTimer);
					tapTimer = null;

					// Check if taped on the same place
					if ( _isNearbyPoints(p0, tapReleasePoint) ) {
						_shout('doubleTap', p0);
						return;
					}
				}

				if(releasePoint.type === 'mouse') {
					_dispatchTapEvent(e, releasePoint, 'mouse');
					return;
				}

				var clickedTagName = e.target.tagName.toUpperCase();
				// avoid double tap delay on buttons and elements that have class pswp__single-tap
				if(clickedTagName === 'BUTTON' || framework.hasClass(e.target, 'quick-view-single-tap') ) {
					_dispatchTapEvent(e, releasePoint);
					return;
				}

				_equalizePoints(tapReleasePoint, p0);

				tapTimer = setTimeout(function() {
					_dispatchTapEvent(e, releasePoint);
					tapTimer = null;
				}, 300);
			}
		}
	}
});

var _scrollAnimFrame;
var _dragDelta = 0;
var _dragPositionY = 0;
var _scrollDelta = 0;
var _scrollTicking = false;
var _cumulativeDelta = 0;
var _touchScrollDrag = false;
var _fakeScrollTotal = 0;
var _renderFakeScrollTotal = 0;
var _eventType = '';
var _lastScrollPosition = null;
var _listeningToScrollWheel = false;
var _startScrollAnimation = function(){
	_isScrollAnimating = true;
	_scrollUpdateLoop();
}
var _stopScrollUpdateLoop = function() {
	if(_scrollAnimFrame) {
		_cancelAF(_scrollAnimFrame);
		_scrollAnimFrame = null;
		_cumulativeDelta = 0;
		_scrollDelta = 0;
		_isScrollAnimating = false;
	}
}

var _resetScrollPosition = function(){

	if ( _isScrollAnimating || _waitingOnClose){
		return;
	}

	var initalPanY = _panOffset.y,
		initialPanX = _panOffset.x,
		initialBgOpacity = _bgOpacity,
		initialZoomLevel = _currZoomLevel;
	// _animateProp = function(name, b, endProp, d, easingFn, onUpdate, onComplete) {
	_animateProp('resetVertical', 0, 1, 300, framework.easing.cubic.out, function(now) {
		_currZoomLevel =  (self.currItem.initialZoomLevel) * now + (1-now)* initialZoomLevel;
		_panOffset.y = (self.currItem.initialPosition.y - initalPanY) * now + initalPanY;

		var newPanX = (self.currItem.initialZoomLevel*parseFloat(self.currItem.w)-_currZoomLevel*parseFloat(self.currItem.w))*.5;
		_panOffset.x = self.currItem.initialPosition.x + newPanX;

		_applyBgOpacity(  (1 - initialBgOpacity) * now + initialBgOpacity );
		_applyCurrentZoomPan();
	});
}

var _scrollUpdateLoop = function() {

	if ( _scrollTicking ){
		return;
	}
	_scrollTicking = true;

	if(_isScrollAnimating) {
		_scrollAnimFrame = _requestAF(_scrollUpdateLoop);
		_renderScrollMovement();
		_scrollTicking  = false;
	}
};

var _waitingOnClose = false;
var _renderScrollMovement = function(){

	if ( !_touchScrollDrag && _listeningToScrollWheel ){
		document.documentElement.scrollTop = document.documentElement.scrollTop + _scrollDelta;		
	}

	var minSize = Math.min(_viewportSize.y, _viewportSize.x);
	var scrollSpeed = Math.abs(_scrollDelta)/ minSize;


	var opacityRatio =Math.max(0,   Math.min((1.3) -  Math.abs( _cumulativeDelta / (minSize / 3)  ), 1) );

	if ( opacityRatio < 0.85 || _waitingOnClose || scrollSpeed > 0.2 ){
		_stopScrollUpdateLoop();
		if(_endScrollTimeout) {
			clearTimeout(_endScrollTimeout);
		}
		if ( !_waitingOnClose  ){
			_waitingOnClose = true;
			
			if ( _touchScrollDrag ){ 
				_closedByScroll = true;
				self.close();
			} else {
				setTimeout(function(){
					_closedByScroll = true;
					self.close();			
				}, 25)
			}
		}


		return;
	}
	_applyBgOpacity(opacityRatio);

	var diff = Math.abs(_cumulativeDelta)/ (_viewportSize.y*.75)

	// don't scale-down on scroll if thumb is larger than actual
	if ( self.currItem.hasOwnProperty('thumbRect') ){

		var smallerThanThumbnail = self.currItem.initialZoomLevel*parseFloat(self.currItem.h) *.5 < self.currItem.thumbRect.h;
		if (smallerThanThumbnail){
			diff = 0;
		}

	}

	_currZoomLevel = (1-(diff*diff))*self.currItem.initialZoomLevel

	var newPanX = (self.currItem.initialZoomLevel*parseFloat(self.currItem.w)-_currZoomLevel*parseFloat(self.currItem.w))*.5;
	var newPanY = (self.currItem.initialZoomLevel*parseFloat(self.currItem.h)-_currZoomLevel*parseFloat(self.currItem.h))*.5;

	_panOffset.y = self.currItem.initialPosition.y+ newPanY+ (-_cumulativeDelta);
	_panOffset.x = self.currItem.initialPosition.x+ newPanX;

	_applyCurrentZoomPan();
	_cumulativeDelta = _cumulativeDelta + _scrollDelta;


	_scrollDelta = 0;
};

var _endScrollTimeout;

/*>>tap*/

/*>>desktop-zoom*/
/**
 *
 * desktop-zoom.js:
 *
 * - Binds mousewheel event for paning zoomed image.
 * - Manages "dragging", "zoomed-in", "zoom-out" classes.
 *   (which are used for cursors and zoom icon)
 * - Adds toggleDesktopZoom function.
 *
 */

var _wheelDelta;

_registerModule('DesktopZoom', {

	publicMethods: {

		initDesktopZoom: function() {

			if(_oldIE) {
				// no zoom for old IE (<=8)
				return;
			}

			if(_likelyTouchDevice) {
				// if detected hardware touch support, we wait until mouse is used,
				// and only then apply desktop-zoom features
				// _listen('mouseUsed', function() {
					self.setupDesktopZoom();
				// });
			} else {
				self.setupDesktopZoom(true);
			}

		},

		setupDesktopZoom: function(onInit) {

			_wheelDelta = {};

			var events = 'wheel mousewheel DOMMouseScroll';

			_listen('bindEvents', function() {
				framework.bind(template, events,  self.handleMouseWheel);
			});

			_listen('unbindEvents', function() {
				if(_wheelDelta) {
					framework.unbind(template, events, self.handleMouseWheel);
				}
			});

			self.mouseZoomedIn = false;

			var hasDraggingClass,
				updateZoomable = function() {
					if(self.mouseZoomedIn) {
						framework.removeClass(template, 'quick-view-zoomed-in');
						self.mouseZoomedIn = false;
					}
					if(_currZoomLevel < 1) {
						framework.addClass(template, 'quick-view-zoom-allowed');
					} else {
						framework.removeClass(template, 'quick-view-zoom-allowed');
					}
					removeDraggingClass();
				},
				removeDraggingClass = function() {
					if(hasDraggingClass) {
						framework.removeClass(template, 'quick-view-dragging');
						hasDraggingClass = false;
					}
				};

			_listen('resize' , updateZoomable);
			_listen('afterChange' , updateZoomable);
			_listen('pointerDown', function() {
				if(self.mouseZoomedIn) {
					hasDraggingClass = true;
					framework.addClass(template, 'quick-view-dragging');
				}
			});
			_listen('pointerUp', removeDraggingClass);

			if(!onInit) {
				updateZoomable();
			}

		},

		handleMouseWheel: function(e) {

			_listeningToScrollWheel = true;

			if(_currZoomLevel <= self.currItem.fitRatio) {
				if( _options.modal ) {

					if (!_options.closeOnScroll || _numAnimations || _isDragging) {
						e.preventDefault();
					} else if(_transformKey && Math.abs(e.deltaY) > 2) {
						// close PhotoSwipe
						// if browser supports transforms & scroll changed enough
						_closedByScroll = true;
						self.close();
					}

				}
				// placing this return further down so we can calc wheeldelta
				// return;

			}


			// https://developer.mozilla.org/en-US/docs/Web/Events/wheel
			_wheelDelta.x = 0;
			if('deltaX' in e) {
				if(e.deltaMode === 1 /* DOM_DELTA_LINE */) {
					// 18 - average line height
					_wheelDelta.x = e.deltaX * 18;
					_wheelDelta.y = e.deltaY * 18;
				} else {
					_wheelDelta.x = e.deltaX;
					_wheelDelta.y = e.deltaY;
				}
			} else if('wheelDelta' in e) {
				if(e.wheelDeltaX) {
					_wheelDelta.x = -0.16 * e.wheelDeltaX;
				}
				if(e.wheelDeltaY) {
					_wheelDelta.y = -0.16 * e.wheelDeltaY;
				} else {
					_wheelDelta.y = -0.16 * e.wheelDelta;
				}

			} else if('detail' in e) {
				_wheelDelta.y = e.detail;
			} else {
				return;
			}

			if( _currZoomLevel <= self.currItem.fitRatio && !_touchScrollDrag){

				_scrollDelta = _scrollDelta+_wheelDelta.y;

				if( _options.modal ) {

					if (!_options.animatedCloseOnScroll || _numAnimations || _isDragging) {
						e.preventDefault();
						_scrollDelta = 0;
					} else if(_transformKey && Math.abs(_wheelDelta.y) > 0 && !_isScrollAnimating) {
						_stopScrollUpdateLoop();
						_startScrollAnimation();
					}

					if(_endScrollTimeout) {
						clearTimeout(_endScrollTimeout);
					}
					_endScrollTimeout = setTimeout(function(){
						_stopScrollUpdateLoop();
						_resetScrollPosition();
					}, 200)
				}

				return;

			} else {
				_scrollDelta = 0;
				// allow just one event to fire
				e.stopPropagation();
			}

			_calculatePanBounds(_currZoomLevel, true);

			var newPanX = _panOffset.x - _wheelDelta.x,
				newPanY = _panOffset.y - _wheelDelta.y;

			// only prevent scrolling in nonmodal mode when not at edges
			if (_options.modal ||
				(
				newPanX <= _currPanBounds.min.x && newPanX >= _currPanBounds.max.x &&
				newPanY <= _currPanBounds.min.y && newPanY >= _currPanBounds.max.y
				) ) {
				e.preventDefault();
			}

			// TODO: use rAF instead of mousewheel?
			self.panTo(newPanX, newPanY);
		},

		toggleDesktopZoom: function(centerPoint) {

			centerPoint = centerPoint || {x:_viewportSize.x/2 + _offset.x, y:_viewportSize.y/2 + _offset.y };

			var doubleTapZoomLevel = _options.getDoubleTapZoom(true, self.currItem);
			var zoomOut = _currZoomLevel === doubleTapZoomLevel;

			self.mouseZoomedIn = !zoomOut;

			self.zoomTo(zoomOut ? self.currItem.initialZoomLevel : doubleTapZoomLevel, centerPoint, 333);
			framework[ (!zoomOut ? 'add' : 'remove') + 'Class'](template, 'quick-view-zoomed-in');

			if ( self.currItem.caption && _options.showCaption){
				if ( zoomOut ){
					self.caption.classList.remove('hidden');
				} else {
					self.caption.classList.add('hidden');
				}
			}
		}

	}
});


/*>>desktop-zoom*/
	framework.extend(self, publicMethods); };
	return PhotoSwipe;
});

this.template =`<div class="quick-view" tabindex="-1" role="dialog" aria-hidden="true"> 
	

</div>`;

var insertTemplate = function(){

	// var div = document.createElement('div');
	var div = document.querySelector('.quick-view-container');

	div.outerHTML = this.template;

	// while(div.childNodes.length > 0) {
	// 	document.body.appendChild(div.childNodes[0]);
	// }

	div = null;

}.bind(this);

var eventProxy = function() {};

this.setEventProxy = function(callback){

	if(typeof callback === "function") {
		eventProxy = callback;
	}

};

var decompose = function (a, b, c, d, e, f, useLU) {

    var acos = Math.acos, // caching for readability below
        atan = Math.atan,
        sqrt = Math.sqrt,
        pi   = Math.PI,

        translate = {x: e, y: f},
        rotation  = 0,
        scale     = {x: 1, y: 1},
        skew      = {x: 0, y: 0},

        determ = a * d - b * c;   // get determinant

    if (useLU) {
        if (a) {
            skew =  {x: atan(c / a), y: atan(b / a)};
            scale = {x: a,           y: determ / a};
        }
        else if (b) {
            rotation = pi * 0.5;
            scale    = {x: b, y: determ / b};
            skew.x   = atan(d / b);
        }
        else { // a = b = 0
            scale  = {x: c, y: d};
            skew.x = pi * 0.25;
        }
    }
    else {
        // Apply the QR-like decomposition.
        if (a || b) {
            var r = sqrt(a*a + b*b);
            rotation = b > 0 ? acos(a / r) : -acos(a / r);
            scale    = {x: r, y: determ / r};
            skew.x   = atan((a*c + b*d) / (r*r));
        }
        else if (c || d) {
            var s = sqrt(c*c + d*d);
            rotation = pi * 0.5 - (d > 0 ? acos(-c / s) : -acos(c / s));
            scale    = {x: determ/s, y: s};
            skew.y   = atan((a*c + b*d) / (s*s));
        }
        else { // a = b = c = d = 0
            scale = {x:0, y:0};     // = invalid matrix
        }
    }

    return {
        scale    : scale,
        translate: translate,
        rotation : rotation,
        skew     : skew
    };
}

this.isActive = false;
this.activeGallery = undefined;

this.openImageArray = function(elementArray, startingIndex, customOptions){
	
 	if(elementArray === undefined || this.activeGallery !== undefined) {
 		return;
 	}

	var pswpElement = document.querySelectorAll('.quick-view')[0];

	var _this = this;

	var contentAlignVertical = customOptions.alignVertical || 'center';
	var contentAlignHorizontal = customOptions.alignHorizontal || 'center';
	var useControls = customOptions.useControls;
	var animatedCloseOnScroll = customOptions.animatedCloseOnScroll;

	var showCaption = customOptions.showCaption;
	var _options = {
		index: startingIndex,
		maxSpreadZoom: 1,
		//hideAnimationDuration: 0,
		getThumbBoundsFn: function(index) {

			if(customOptions && customOptions.preventAnimation) {
				return false;
			}

			if(_this.activeGallery == undefined) {
				return false;
			}

			var item = _this.activeGallery.getItemAt(index);
			var measureEl;
			if( !item || !item.el){
				return false;
			}

			if ( item.el.tagName === 'A'){
				measureEl = item.el.querySelector('media-item, video, iframe, img') || item.el;
			} else {
				measureEl = item.el;
			}





			// if it's a marquee with a clone and we're closing the lightbox, we don't know where the thing might have gotten to in the meantime
			// so we just close it without a rect if that's the case
			let closestMarquee = measureEl.closest('marquee-set');
			if( closestMarquee ){

				let marqueeInner = closestMarquee.querySelector('marquee-inner[slot="contents"]')
				let marqueeInnerClone = closestMarquee.querySelector('marquee-inner[slot="contents-clone"]');

				if(_this.isActive && marqueeInnerClone) {
					return false;
				}

			}

			if( measureEl && measureEl.tagName==='MEDIA-ITEM'){
				measureEl = measureEl.shadowRoot.querySelector('[part*="media"]');
			}

			if ( !measureEl ){
				return false;
			}


			// make sure the element is inside a document
			let rootNode = measureEl.getRootNode();

			while( rootNode && rootNode !== document ){

				if( rootNode instanceof ShadowRoot ){
					rootNode = rootNode.host.getRootNode()
				} else {
					// the rootnode of a detached element is itself; exit
					rootNode = undefined;	
				}
				
			}

			if( !rootNode){
				return false;
			}



			let style  = getComputedStyle(measureEl);

			let topPad = parseFloat( style.getPropertyValue('padding-top') ) || 0;
			let bottomPad = parseFloat( style.getPropertyValue('padding-bottom') ) || 0;
			let leftPad = parseFloat( style.getPropertyValue('padding-left') ) || 0;
			let rightPad = parseFloat( style.getPropertyValue('padding-right') ) || 0;
			let topBorder = parseFloat( style.getPropertyValue('border-top') ) || 0;
			let bottomBorder = parseFloat( style.getPropertyValue('border-bottom') ) || 0;
			let leftBorder = parseFloat( style.getPropertyValue('border-left') ) || 0;
			let rightBorder = parseFloat( style.getPropertyValue('border-right') ) || 0;



			let globalDecomposition = {
				rotation: 0,
				scale: {
					x: 1,
					y: 1,
				},
				skew: {
					x: 0,
					y: 0
				},
				translate: {
					x: 0,
					y: 0
				}				
			};

			let offsetParent = measureEl;
			let transformParent = measureEl;
			let offsetX = 0;
			let offsetY = 0;
			let offsetWidth = 0;
			let offsetHeight = 0;

			while(offsetParent){
				style  = getComputedStyle(offsetParent);

				topPad = parseFloat( style.getPropertyValue('padding-top') ) || 0;
				bottomPad = parseFloat( style.getPropertyValue('padding-bottom') ) || 0;
				leftPad = parseFloat( style.getPropertyValue('padding-left') ) || 0;
				rightPad = parseFloat( style.getPropertyValue('padding-right') ) || 0;
				topBorder = parseFloat( style.getPropertyValue('border-top') ) || 0;
				bottomBorder = parseFloat( style.getPropertyValue('border-bottom') ) || 0;
				leftBorder = parseFloat( style.getPropertyValue('border-left') ) || 0;
				rightBorder = parseFloat( style.getPropertyValue('border-right') ) || 0;					

				if( offsetParent ==measureEl){
					// add border/pad into x/y
					offsetWidth = offsetParent.offsetWidth - (leftPad+leftBorder + rightPad + rightBorder);
					offsetHeight = offsetParent.offsetHeight - (topPad + topBorder + bottomPad + bottomBorder);	

					// start off by gathering the offsets
					offsetX= offsetX + offsetParent.offsetLeft + leftBorder +leftPad;
					offsetY= offsetY + offsetParent.offsetTop  + topBorder + topPad;
				} else {
					offsetX= offsetX + offsetParent.offsetLeft + leftBorder;
					offsetY= offsetY + offsetParent.offsetTop  + topBorder;
				}


				offsetParent = offsetParent.offsetParent;

			}

			let scrollOffsets = [];


			while(transformParent){


				// then gather the transforms
				let transform = [];
				let parentStyle = getComputedStyle(transformParent);
				let styleMatrix = parentStyle.getPropertyValue('transform');
				let isFixed = parentStyle.getPropertyValue('position') === 'fixed';

				let decomposed;

				var is2dMatrix = styleMatrix.indexOf('matrix(') > -1;
				var is3dMatrix = styleMatrix.indexOf('matrix3d(') > -1;

				var hasTransform = is2dMatrix || is3dMatrix;

				if ( is2dMatrix){
					transform = styleMatrix.replace(")", "").replace("matrix(", "").split(',');
					for(var i = 0; i< transform.length; i++){
						transform[i] = parseFloat(transform[i]);
					}

					decomposed = decompose(transform[0],transform[1],transform[2],transform[3],transform[4],transform[5], false);

				} else if ( is3dMatrix) {
					transform = styleMatrix.replace(")", "").replace("matrix3d(", "").split(',');
					for(var i = 0; i< transform.length; i++){
						transform[i] = parseFloat(transform[i]);
					}
					// see https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/matrix
					decomposed = decompose(transform[0],transform[1],transform[4],transform[5],transform[12],transform[13], false);

				} else {
					decomposed = {
						rotation: 0,
						scale: {
							x: 1,
							y: 1,
						},
						skew: {
							x: 0,
							y: 0
						},
						translate: {
							x: 0,
							y: 0
						}
					}
				}

				if( hasTransform ){

					// center of x/y
					let cx = offsetX + offsetWidth*.5;
					let cy = offsetY + offsetHeight*.5;

					// translate point to origin
					let tempX = offsetX - cx;
					let tempY = offsetY - cy;

					// now apply rotation
					let rotatedX = tempX*Math.cos(decomposed.rotation) - tempY*Math.sin(decomposed.rotation);
					let rotatedY = tempX*Math.sin(decomposed.rotation) + tempY*Math.cos(decomposed.rotation);

					// translate back
					offsetX = rotatedX + cx;
					offsetY = rotatedY + cy;

					// add drag/transition/etc translations into x/y
					offsetX += decomposed.translate.x;
					offsetY += decomposed.translate.y;

					globalDecomposition.rotation = decomposed.rotation + globalDecomposition.rotation;
					globalDecomposition.scale.x = decomposed.scale.x + globalDecomposition.scale.x;
					globalDecomposition.scale.y = decomposed.scale.y + globalDecomposition.scale.y;
					globalDecomposition.translate.y = decomposed.translate.y + globalDecomposition.translate.y;
					globalDecomposition.translate.x = decomposed.translate.x + globalDecomposition.translate.x;
				
				}

				if (transformParent?.assignedSlot){
					transformParent = transformParent.assignedSlot;
				} else {
					transformParent = transformParent.parentNode;					
				}

				if( transformParent?.nodeType === Node.DOCUMENT_FRAGMENT_NODE ){
					transformParent = transformParent.host;
				}


				if( transformParent?.nodeType !== Node.ELEMENT_NODE){
					transformParent = null;
				}

				if( transformParent){
					if ( isFixed ){
						scrollOffsets.push('fixed');
					} else {
						scrollOffsets.push(transformParent.scrollTop);
					}
					
				}
			}

			const fixedIndex = scrollOffsets.findIndex(offset=>offset==='fixed');
			if( fixedIndex !== -1){
				scrollOffsets = scrollOffsets.slice(0, fixedIndex);
			}
			const scrollOffset = scrollOffsets.reduce((num, val=0)=> num+val);

			offsetY= offsetY-scrollOffset;



			var thumbRect = {
				x: offsetX,
				y: offsetY,
				w: offsetWidth,
				h: offsetHeight,
				padding: {
					top: topPad,
					bottom: bottomPad,
					left: leftPad,
					right: rightPad,
				},
				border: {
					top: topBorder,
					bottom: bottomBorder,
					left: leftBorder,
					right: rightBorder,
				},

				transform: globalDecomposition
			};

			item.thumbRect = thumbRect;	

			return thumbRect;


		},
		closeEl:true,
		arrowEl: false,
		tapToClose: true,
		closeOnScroll: false,
		alignHorizontal: contentAlignHorizontal,
		alignVertical: contentAlignVertical,
		useControls: useControls, 
		animatedCloseOnScroll: animatedCloseOnScroll,
		showCaption: showCaption
	};

	var zoomDisabled = false;
	var isTouching = false;
	var onTouchStart = function(){
		isTouching = true;
	}

	var onTouchEnd = function(){
		isTouching = false;
	}

	window.addEventListener('touchend',onTouchEnd);
	window.addEventListener('touchstart',onTouchStart);


	// extend default options with custom options
	if(customOptions !== undefined && typeof customOptions === "object") {

		for (var prop in customOptions) {
			if (customOptions.hasOwnProperty(prop)) {
				_options[prop] = customOptions[prop];
			}
		}

		if(customOptions.disableZoom === true) {

			zoomDisabled = true;

			_options.zoomEl = false;

			_options.getDoubleTapZoom = function(isMouseClick, item) {
				return item.initialZoomLevel;
			}

			_options.pinchToClose = false;

		}

	}

	// Initializes and opens PhotoSwipe
	this.activeGallery = new this.PhotoSwipe( pswpElement, this.PhotoSwipeUI_Default, elementArray, _options);

	if( customOptions.afterInit){
		this.activeGallery.listen('afterInit', customOptions.afterInit);
	}

	if(zoomDisabled) {
		pswpElement.classList.add('quick-view-zoom-disabled');
	} else {
		pswpElement.classList.remove('quick-view-zoom-disabled');
	}

	this.activeGallery.init();


	this.isActive = true;
	// keep active image array around so we can compare it to an inactive array when clicked
	this.activeGallery.elementArray = elementArray;


	this.activeGallery.listen('destroy', function(){

		if(pswpElement.parentNode !== null) {

			if ( isTouching ){
				// Cargo.Event.once('lightbox-scroll-finished', function(){
					pswpElement.parentNode.removeChild(pswpElement);
					window.removeEventListener('touchend',onTouchEnd);
					window.removeEventListener('touchstart',onTouchStart);
				// });
			} else {
				pswpElement.parentNode.removeChild(pswpElement);
				window.removeEventListener('touchend',onTouchEnd);
				window.removeEventListener('touchstart',onTouchStart);				
			}

		} else {
			window.removeEventListener('touchend',onTouchEnd);
			window.removeEventListener('touchstart',onTouchStart);			
		}

		_this.isActive = false;
		_this.activeGallery = undefined;

	});

	return this.activeGallery;

 };



/*! PhotoSwipe Default UI - 4.1.1 - 2015-12-24
 * http://photoswipe.com
 * Copyright (c) 2015 Dmitry Semenov; */
/**
 *
 * UI on top of main sliding area (caption, arrows, close button, etc.).
 * Built just using public methods/properties of PhotoSwipe.
 *
 */
(function(root, factory) {
	if(root === undefined && window !== undefined) root = window
	root.PhotoSwipeUI_Default = factory();

})(this, function() {

	'use strict';

	var PhotoSwipeUI_Default =
		function(pswp, framework) {

			var ui = this;
			var _overlayUIUpdated = false,
				_controlsVisible = true,
				_fullscrenAPI,
				_controls,
				_initalCloseOnScrollValue,
				_isIdle,
				_listen,

				_galleryHasOneSlide,

				_options,
				_defaultUIOptions = {
					closeElClasses: ['holder', 'caption', 'zoom-wrap', 'ui', 'top-bar', 'container'],
					timeToIdle: 1500,
					timeToIdleOutside: 1500,

					closeEl: true,
					fullscreenEl: true,
					zoomEl: true,
					counterEl: true,
					arrowEl: true,

					tapToClose: false,
					tapToToggleControls: true,

					useControls: false,

					clickToCloseNonZoomable: true,

					fitControlsWidth: 1200

				},
				_blockControlsTap,
				_blockControlsTapTimeout;



			var _onControlsTap = function(e) {

					if (_blockControlsTap) {
						return true;
					}

					e = e || window.event;

					if (_options.timeToIdle && _options.mouseUsed && !_isIdle) {
						// reset idle timer
						_onIdleMouseMove();
					}


					var target = e.target || e.srcElement;

					while(
						target.nodeName === "svg"
						|| target.nodeName === "path"
						|| target.nodeName === "circle"
						|| target.nodeName === "polyline"
						|| target.nodeName === "g"
						|| target.nodeName === "foreignObject"
						|| target.nodeName === "line"
					) {
						target = target.parentNode;
					}

					var	uiElement,
						clickedClass = target.getAttribute('class') || '',
						found;

					for (var i = 0; i < _uiElements.length; i++) {
						uiElement = _uiElements[i];
						if (uiElement.onTap && clickedClass.indexOf('quick-view-' + uiElement.name) > -1) {
							uiElement.onTap();
							found = true;
						}
					}

					if (found) {
						if (e.stopPropagation) {
							e.stopPropagation();
						}
						_blockControlsTap = true;

						// Some versions of Android don't prevent ghost click event
						// when preventDefault() was called on touchstart and/or touchend.
						//
						// This happens on v4.3, 4.2, 4.1,
						// older versions strangely work correctly,
						// but just in case we add delay on all of them)
						var tapDelay = framework.features.isOldAndroid ? 600 : 30;
						_blockControlsTapTimeout = setTimeout(function() {
							_blockControlsTap = false;
						}, tapDelay);
					}

				},
				_fitControlsInViewport = function() {
					return !pswp.likelyTouchDevice || _options.mouseUsed || screen.width > _options.fitControlsWidth;
				},
				_togglePswpClass = function(el, cName, add) {
					framework[(add ? 'add' : 'remove') + 'Class'](el, 'quick-view-' + cName);
				},
				_hasCloseClass = function(target) {
					for (var i = 0; i < _options.closeElClasses.length; i++) {
						if (framework.hasClass(target, 'quick-view-' + _options.closeElClasses[i])) {
							return true;
						}
					}
				},
				_idleInterval,
				_idleTimer,
				_idleIncrement = 0,
				_mouseOverUIElement = false,
				_onIdleMouseMove = function(e) {

					if ( e ){	
						var navSVG = helpers.closest(e.target, function(el){

							if(el && el.nodeType === Node.ELEMENT_NODE ) {
								return (
									el.classList.contains('left-arrow') ||
									el.classList.contains('right-arrow') ||
									el.classList.contains('close-button')
								)
							}
						})

						_mouseOverUIElement = navSVG ? true : false

					}

					clearTimeout(_idleTimer);
					_idleIncrement = 0;
					if (_isIdle) {
						ui.setIdle(false);
					}

				},
				_onMouseLeaveWindow = function(e) {
					e = e ? e : window.event;
					var from = e.relatedTarget || e.toElement;
					if (!from || from.nodeName === 'HTML') {
						clearTimeout(_idleTimer);
						_idleTimer = setTimeout(function() {
							ui.setIdle(true);
						}, _options.timeToIdleOutside);
					}
				},
				_setupFullscreenAPI = function() {
					if (_options.fullscreenEl && !framework.features.isOldAndroid) {
						if (!_fullscrenAPI) {
							_fullscrenAPI = ui.getFullscreenAPI();
						}
						if (_fullscrenAPI) {
							framework.bind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
							ui.updateFullscreen();
							framework.addClass(pswp.template, 'quick-view-supports-fs');
						} else {
							framework.removeClass(pswp.template, 'quick-view-supports-fs');
						}
					}
				},
				_setupIdle = function() {
					// Hide controls when mouse is used
					if (_options.timeToIdle) {
						_listen('mouseUsed', function() {

							framework.bind(document, 'mousemove', _onIdleMouseMove);
							framework.bind(document, 'mouseout', _onMouseLeaveWindow);

							_idleInterval = setInterval(function() {
								_idleIncrement++;
								if (_idleIncrement === 2) {
									ui.setIdle(true);
								}
							}, _options.timeToIdle / 2);
						});
					}
				},
				_setupHidingControlsDuringGestures = function() {

					// Hide controls on vertical drag
					_listen('onVerticalDrag', function(now) {
						if (_controlsVisible && now < 0.95) {
							ui.hideControls();
						} else if (!_controlsVisible && now >= 0.95) {
							ui.showControls();
						}
					});

					// Hide controls when pinching to close
					var pinchControlsHidden;
					_listen('onPinchClose', function(now) {
						if (_controlsVisible && now < 0.9) {
							ui.hideControls();
							pinchControlsHidden = true;
						} else if (pinchControlsHidden && !_controlsVisible && now > 0.9) {
							ui.showControls();
						}
					});

					_listen('zoomGestureEnded', function() {
						pinchControlsHidden = false;
						if (pinchControlsHidden && !_controlsVisible) {
							ui.showControls();
						}
					});

				};

			var _uiElements = [{
					name: 'button--zoom',
					option: 'zoomEl',
					onTap: pswp.toggleDesktopZoom
				}, {
					name: 'button-close',
					option: 'closeEl',
					onTap: pswp.close
				}, {
					name: 'button-prev',
					option: 'arrowEl',
					onTap: pswp.prev
				}, {
					name: 'button-next',
					option: 'arrowEl',
					onTap: pswp.next
				}, {
					name: 'button--fs',
					option: 'fullscreenEl',
					onTap: function() {
						if (_fullscrenAPI.isFullscreen()) {
							_fullscrenAPI.exit();
						} else {
							_fullscrenAPI.enter();
						}
					}
				}

			];

			var _setupUIElements = function() {

				var item,
					classAttr,
					uiElement;

				var loopThroughChildElements = function(sChildren) {
					if (!sChildren) {
						return;
					}

					var l = sChildren.length,
						activeChildren = [];

					for (var i = 0; i < l; i++) {
						item = sChildren[i];
						classAttr = item.className;

						for (var a = 0; a < _uiElements.length; a++) {
							uiElement = _uiElements[a];

							if (classAttr.indexOf('quick-view-' + uiElement.name) > -1) {

								if (_options[uiElement.option]) { // if element is not disabled from options

									framework.removeClass(item, 'quick-view-element--disabled');

									activeChildren.push(item);

									if (uiElement.onInit) {
										uiElement.onInit(item);
									}

								} else {
									framework.addClass(item, 'quick-view-element--disabled');
								}
							}
						}
					}

					if(activeChildren.length > 0) {
						//framework.addClass(activeChildren[0], 'quick-view-first-group-element');
						//framework.addClass(activeChildren[activeChildren.length  - 1], 'quick-view-last-group-element');
					}

				};

				loopThroughChildElements(_controls.children);

				var groups = _controls.querySelectorAll('.quick-view-group');

				for (var i = 0; i < groups.length; i++) {
					loopThroughChildElements(groups[i].children);
				}

			};

			ui.init = function() {


				// extend options
				framework.extend(pswp.options, _defaultUIOptions, true);

				// create local link for fast access
				_options = pswp.options;

				// find quick-view-ui element
				_controls = framework.getChildByClass(pswp.scrollWrap, 'quick-view-ui');

				// create local link
				_listen = pswp.listen;



				// _setupHidingControlsDuringGestures();

				// update controls when slides change
				_listen('beforeChange', ui.update);

				// toggle zoom on double-tap
				_listen('doubleTap', function(point) {
					var initialZoomLevel = pswp.currItem.initialZoomLevel;
					if (pswp.getZoomLevel() !== initialZoomLevel) {
						pswp.zoomTo(initialZoomLevel, point, 333);
					} else {
						pswp.zoomTo(_options.getDoubleTapZoom(false, pswp.currItem), point, 333);
					}
				});

				// Allow text selection in caption
				_listen('preventDragEvent', function(e, isDown, preventObj) {
					var t = e.target || e.srcElement;
					if (
						t &&
						t.getAttribute('class') && e.type.indexOf('mouse') > -1 &&
						(t.getAttribute('class').indexOf('__caption') > 0 || (/(SMALL|STRONG|EM)/i).test(t.tagName))
					) {
						preventObj.prevent = false;
					}
				});

				// clean up things when gallery is destroyed
				_listen('destroy', function() {
					if (_options.captionEl) {
						if (_fakeCaptionContainer) {
							_controls.removeChild(_fakeCaptionContainer);
						}
						framework.removeClass(_captionContainer, 'quick-view-caption--empty');
					}

					// ui.setIdle(false);
				});

			

				// start idle timeout to hide nav
				// if mouse doesn't move after opening
				// clearTimeout(_idleTimer);
				// _idleTimer = setTimeout(function() {
				// 	ui.setIdle(true);
				// }, _options.timeToIdleOutside);

				ui.bindEvents();

				_setupFullscreenAPI();
			};


			ui.unbindEvents = function(){

				if (_idleInterval) {
					clearInterval(_idleInterval);
				}
				framework.unbind(document, 'mouseout', _onMouseLeaveWindow);
				framework.unbind(document, 'mousemove', _onIdleMouseMove);
				// framework.unbind(_controls, 'pswpTap click', _onControlsTap);
				framework.unbind(pswp.scrollWrap, 'pswpTap', ui.onGlobalTap);
				// framework.unbind(pswp.scrollWrap, 'mouseover', ui.onMouseOver);
				window.removeEventListener('mousedown', ui.onGlobalClick);
				if (_fullscrenAPI) {
					framework.unbind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
					if (_fullscrenAPI.isFullscreen()) {
						_options.hideAnimationDuration = 0;
						_fullscrenAPI.exit();
					}
					_fullscrenAPI = null;
				}				
			}

			ui.setupIdle = function(){
				_setupIdle();				
			}

			ui.bindEvents = function(){

				if ( _options.useControls ){
					// framework.bind(_controls, 'pswpTap click', _onControlsTap);
				} 
				window.addEventListener('mousedown', ui.onGlobalClick);
				framework.bind(pswp.scrollWrap, 'pswpTap', ui.onGlobalTap);

				if (!pswp.likelyTouchDevice) {
					// framework.bind(pswp.scrollWrap, 'mouseover', ui.onMouseOver);
				}
			}

			ui.setIdle = function(isIdle) {

				if( window.store?.getState()?.frontendState?.adminMode ){ return }

				if ( _mouseOverUIElement ){
					return;
				}

				_isIdle = isIdle;
				// _togglePswpClass(_controls, 'ui--idle', isIdle);
			};

			ui.update = function() {
				// Don't update UI if it's hidden
				if (_controlsVisible && pswp.currItem) {

					_overlayUIUpdated = true;

				} else {
					_overlayUIUpdated = false;
				}

			};

			ui.updateFullscreen = function(e) {

				if (e) {
					// some browsers change window scroll position during the fullscreen
					// so PhotoSwipe updates it just in case
					setTimeout(function() {
						pswp.setScrollOffset(0, framework.getScrollY());
					}, 50);
				}

				// toogle pswp--fs class on root element
				framework[(_fullscrenAPI.isFullscreen() ? 'add' : 'remove') + 'Class'](pswp.template, 'quick-view-fs');
			};

			ui.onGlobalClick = function(e){

				const closestQuickViewItem = e.target.closest('.quick-view, media-item:not([disable-zoom="true"]), href[rel="quick-view"]');

				// click behavior for these items is handled elsewhere
				if( closestQuickViewItem && (closestQuickViewItem.getAttribute('rel') == 'quick-view' || closestQuickViewItem.nodeName === 'MEDIA-ITEM') ){
					const indexOfEl = pswp.elementArray.findIndex(item=>item.el == closestQuickViewItem);

					if( indexOfEl === -1){
						pswp.close();
					} 

				} else if (!closestQuickViewItem) {	
					pswp.close();
				}
			}

			ui.onGlobalTap = function(e) {
				e = e || window.event;
				var target = e.target || e.srcElement;
				if (_blockControlsTap) {
					return;
				}
				if (e.detail && e.detail.pointerType === 'mouse') {
					// close gallery if clicked outside of the image
					if (_hasCloseClass(target)) {
						pswp.close();
						return;
					}

					if (framework.hasClass(target, 'quick-view-item')) {
						if(_options.disableZoom) {
							const fileType = target.getFileType?.();

							// autoplaying items get closed on click like normal images, non-autoplaying videos do not
							if( fileType && !pswp.currItem.autoplay &&
								(fileType.startsWith('vimeo') || fileType.startsWith('youtube') || fileType ==='video')
							 ){
								return;
							} else {
								pswp.close();								
							}

							return;

						} if (pswp.getZoomLevel() === 1 && pswp.getZoomLevel() <= pswp.currItem.fitRatio) {
							if (_options.clickToCloseNonZoomable) {
								pswp.close();
								return;
							}
						} else {
							pswp.toggleDesktopZoom(e.detail.releasePoint);
						}

					}

				} else {

					// tap anywhere (except buttons) to toggle visibility of controls
					if (_options.tapToToggleControls) {
						if (_controlsVisible) {
							ui.hideControls();
						} else {
							ui.showControls();
						}
					}

					// tap to close gallery
					if (_options.tapToClose && (framework.hasClass(target, 'quick-view-item') || _hasCloseClass(target))) {
						// videos and urls need to stay interactive.... only close on images.
						if ( !target.getFileType || target.getFileType?.() === 'image' ){
							pswp.close();
						}

						return;
					}

				}
			};

			ui.onMouseOver = function(e) {
				e = e || window.event;
				var target = e.target || e.srcElement;

				// add class when mouse is over an element that should close the gallery
				_togglePswpClass(_controls, 'ui--over-close', _hasCloseClass(target));
			};

			ui.hideControls = function() {
				return;
				framework.addClass(_controls, 'quick-view-ui--hidden');

				if ( !_options.useControls){
					framework.addClass(_controls, 'quick-view-ui--displaynone');					
				}
				_controlsVisible = false;
			};

			ui.showControls = function() {
				return;
				if ( !_options.useControls ){
					return
				}
				_controlsVisible = true;
				if (!_overlayUIUpdated) {
					ui.update();
				}
				framework.removeClass(_controls, 'quick-view-ui--displaynone');				
				framework.removeClass(_controls, 'quick-view-ui--hidden');
			};

			ui.toggleFullscreen = function(){
				if (_fullscrenAPI.isFullscreen()) {
					_fullscrenAPI.exit();
				} else {
					_fullscrenAPI.enter();
				}
			};

			ui.supportsFullscreen = function() {
				var d = document;
				return !!(d.exitFullscreen || d.mozCancelFullScreen || d.webkitExitFullscreen || d.msExitFullscreen);
			};

			ui.getFullscreenAPI = function() {
				var dE = document.documentElement,
					api,
					tF = 'fullscreenchange';

				if (dE.requestFullscreen) {
					api = {
						enterK: 'requestFullscreen',
						exitK: 'exitFullscreen',
						elementK: 'fullscreenElement',
						eventK: tF
					};

				} else if (dE.mozRequestFullScreen) {
					api = {
						enterK: 'mozRequestFullScreen',
						exitK: 'mozCancelFullScreen',
						elementK: 'mozFullScreenElement',
						eventK: 'moz' + tF
					};



				} else if (dE.webkitRequestFullscreen) {
					api = {
						enterK: 'webkitRequestFullscreen',
						exitK: 'webkitExitFullscreen',
						elementK: 'webkitFullscreenElement',
						eventK: 'webkit' + tF
					};

				} else if (dE.msRequestFullscreen) {
					api = {
						enterK: 'msRequestFullscreen',
						exitK: 'msExitFullscreen',
						elementK: 'msFullscreenElement',
						eventK: 'MSFullscreenChange'
					};
				}

				if (api) {
					api.enter = function() {
						// disable close-on-scroll in fullscreen
						_initalCloseOnScrollValue = _options.closeOnScroll;
						_options.closeOnScroll = false;

						if (this.enterK === 'webkitRequestFullscreen') {
							pswp.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT);
						} else {
							return pswp.template[this.enterK]();
						}
					};
					api.exit = function() {
						_options.closeOnScroll = _initalCloseOnScrollValue;

						return document[this.exitK]();

					};
					api.isFullscreen = function() {
						return document[this.elementK];
					};
				}

				return api;
			};

		};

	return PhotoSwipeUI_Default;

});}.call( lightboxRoot ));